{
  "starters": {
    "rewards": [
      {
        "key": "homework",
        "name": "PR tepat waktu",
        "emoji": "✓"
      },
      {
        "key": "help",
        "name": "Suka menolong",
        "emoji": "🤝"
      },
      {
        "key": "cooperate",
        "name": "Kerja sama tim",
        "emoji": "🌿"
      },
      {
        "key": "focus",
        "name": "Fokus di kelas",
        "emoji": "👀"
      },
      {
        "key": "raise-hand",
        "name": "Tunjuk tangan",
        "emoji": "✋"
      },
      {
        "key": "challenge",
        "name": "Tantangan tuntas",
        "emoji": "⭐"
      }
    ],
    "reminders": [
      {
        "key": "chatting",
        "name": "Mengobrol di kelas",
        "emoji": "💬"
      },
      {
        "key": "materials",
        "name": "Lupa bawa alat",
        "emoji": "🎒"
      },
      {
        "key": "late-homework",
        "name": "PR terlambat",
        "emoji": "📋"
      },
      {
        "key": "disturbing",
        "name": "Kurang fokus",
        "emoji": "🔔"
      }
    ],
    "homework": [
      {
        "key": "language-workbook",
        "name": "Jurnal baca",
        "emoji": "📖"
      },
      {
        "key": "language-writing",
        "name": "Ejaan kata",
        "emoji": "✏️"
      },
      {
        "key": "math-workbook",
        "name": "Matematika",
        "emoji": "🧮"
      },
      {
        "key": "contact-book",
        "name": "Buku agenda",
        "emoji": "📝"
      }
    ],
    "daily": [
      {
        "key": "morning-reading",
        "name": "Tugas pagi",
        "emoji": "☀️"
      },
      {
        "key": "reading",
        "name": "Baca 20 mnt",
        "emoji": "📚"
      },
      {
        "key": "water",
        "name": "Botol minum",
        "emoji": "💧"
      },
      {
        "key": "cleaning",
        "name": "Meja rapi",
        "emoji": "🧹"
      },
      {
        "key": "materials",
        "name": "Bongkar tas",
        "emoji": "🎒"
      }
    ],
    "store": [
      {
        "key": "sticker",
        "name": "Stiker keren",
        "emoji": "🌈",
        "points": 5
      },
      {
        "key": "library-first",
        "name": "Pilih buku duluan",
        "emoji": "📚",
        "points": 8
      },
      {
        "key": "helper",
        "name": "Asisten guru",
        "emoji": "🤝",
        "points": 10
      },
      {
        "key": "seat",
        "name": "Pilih tempat duduk",
        "emoji": "🪑",
        "points": 15
      },
      {
        "key": "social-treat",
        "name": "Makan bareng guru",
        "emoji": "🍱",
        "points": 15
      },
      {
        "key": "homework-pass",
        "name": "Kupon bebas PR",
        "emoji": "📝",
        "points": 20
      },
      {
        "key": "mystery",
        "name": "Hadiah misteri",
        "emoji": "🎁",
        "points": 25
      },
      {
        "key": "top-prize",
        "name": "Duduk di kursi guru",
        "emoji": "👑",
        "points": 30
      }
    ],
    "instructions": [
      {
        "key": "ready",
        "title": "Siap belajar",
        "steps": [
          "Keluarkan buku dan alat tulis",
          "Buka halaman yang tertulis di papan",
          "Perhatikan ke depan"
        ]
      },
      {
        "key": "group",
        "title": "Diskusi kelompok",
        "steps": [
          "Sampaikan pendapat secara bergantian",
          "Tulis hasil jawaban kelompokmu",
          "Pilih satu juru bicara"
        ]
      },
      {
        "key": "finished",
        "title": "Selesai lebih awal?",
        "steps": [
          "Pastikan namamu sudah ditulis",
          "Kumpulkan tugas ke depan",
          "Membaca buku dengan tenang"
        ]
      },
      {
        "key": "pack-up",
        "title": "Beres-beres pulang",
        "steps": [
          "Rapikan barang di atas meja",
          "Masukkan kursi dan pungut sampah di sekitar",
          "Berbaris dengan rapi dan tenang"
        ]
      }
    ],
    "phrases": [
      "Mohon tanda tangan orang tua",
      "Perbaikan dikumpulkan besok",
      "Kembalikan formulir besok",
      "Bawa botol minum sendiri",
      "Jangan lupa bawa jaket",
      "Pakai sepatu olahraga besok",
      "Besok ada ulangan ejaan",
      "Waktunya kembalikan buku"
    ],
    "duties": [
      "Ketua baris",
      "Hapus papan",
      "Bagi kertas",
      "Piket sampah",
      "Jaga lampu",
      "Jaga pintu"
    ]
  },
  "certificate": {
    "awards": [
      {
        "id": "star",
        "label": "Siswa teladan",
        "title": "Siswa Teladan",
        "phrases": [
          "Karena selalu bersinar setiap hari dengan kerja keras, kebaikan hati, dan sikap yang hebat.",
          "Karena telah menjadi teladan yang luar biasa bagi seluruh kelas.",
          "Karena selalu berusaha memberikan yang terbaik dan membawa keceriaan di kelas kita."
        ],
        "suffix": ""
      },
      {
        "id": "improved",
        "label": "Kemajuan terbaik",
        "title": "Kemajuan Terbaik",
        "phrases": [
          "Karena telah bekerja keras sepanjang tahun dan menunjukkan kemajuan yang luar biasa.",
          "Karena tidak pernah menyerah meski menghadapi kesulitan. Lihat betapa jauh kemajuan yang telah kamu capai!"
        ],
        "suffix": ""
      },
      {
        "id": "reading",
        "label": "Juara membaca",
        "title": "Juara Membaca",
        "phrases": [
          "Karena telah membaca begitu banyak buku hebat dan membagikan kecintaanmu pada cerita.",
          "Karena selalu gemar membaca buku dan punya cerita menarik untuk dibagikan."
        ],
        "suffix": ""
      },
      {
        "id": "attendance",
        "label": "Kehadiran sempurna",
        "title": "Kehadiran Sempurna",
        "phrases": [
          "Karena selalu hadir tepat waktu setiap hari.",
          "Karena selalu hadir dengan semangat belajar setiap hari sepanjang semester ini."
        ],
        "suffix": ""
      },
      {
        "id": "kindness",
        "label": "Penghargaan kebaikan hati",
        "title": "Penghargaan Kebaikan Hati",
        "phrases": [
          "Karena selalu bersikap baik, peduli, dan siap membantu teman.",
          "Karena selalu membuat semua teman di kelas merasa diterima dan dihargai."
        ],
        "suffix": ""
      },
      {
        "id": "math",
        "label": "Jago matematika",
        "title": "Jago Matematika",
        "phrases": [
          "Karena pemikiran yang cerdas dan semangat yang tinggi dalam memecahkan soal.",
          "Karena selalu tekun belajar matematika dan tidak pernah gentar menghadapi tantangan."
        ],
        "suffix": ""
      },
      {
        "id": "helper",
        "label": "Penolong hebat",
        "title": "Penolong Hebat",
        "phrases": [
          "Karena selalu sigap membantu guru dan teman-teman sekelas.",
          "Karena menjadi teman yang ringan tangan dan dapat diandalkan oleh semua orang."
        ],
        "suffix": ""
      },
      {
        "id": "speller",
        "label": "Jago mengeja",
        "title": "Jago Mengeja",
        "phrases": [
          "Karena tekun berlatih mengeja dan berhasil menguasai kata-kata yang sulit.",
          "Karena selalu teliti dan tepat dalam mengeja pada setiap tulisanmu."
        ],
        "suffix": ""
      },
      {
        "id": "creative",
        "label": "Pemikir kreatif",
        "title": "Pemikir Kreatif",
        "phrases": [
          "Karena ide-ide cemerlang, imajinasi yang luas, dan cara berpikir yang kreatif.",
          "Atas cara-cara kreatif dalam memecahkan masalah dan berbagi ide."
        ],
        "suffix": ""
      },
      {
        "id": "leadership",
        "label": "Kepemimpinan",
        "title": "Penghargaan Kepemimpinan",
        "phrases": [
          "Atas sikap memberi teladan dan membangkitkan potensi terbaik dalam diri orang lain.",
          "Karena telah menjadi pemimpin yang bertanggung jawab dan menghargai sesama di kelas kita."
        ],
        "suffix": ""
      },
      {
        "id": "citizen",
        "label": "Warga kelas yang baik",
        "title": "Warga Kelas Teladan",
        "phrases": [
          "Karena bersikap hormat, bertanggung jawab, dan adil kepada semua orang.",
          "Karena telah menjadikan kelas dan sekolah kita tempat yang lebih baik bagi semua."
        ],
        "suffix": ""
      },
      {
        "id": "worker",
        "label": "Pekerja keras",
        "title": "Pekerja Keras",
        "phrases": [
          "Karena selalu memberikan usaha terbaik setiap hari.",
          "Karena tetap fokus dan bekerja keras dalam setiap tugas."
        ],
        "suffix": ""
      },
      {
        "id": "science",
        "label": "Bintang sains",
        "title": "Bintang Sains",
        "phrases": [
          "Atas pertanyaan penuh rasa ingin tahu, pengamatan yang cermat, dan eksperimen yang hebat.",
          "Atas kecintaanmu dalam mencari tahu cara kerja dunia."
        ],
        "suffix": ""
      },
      {
        "id": "writing",
        "label": "Penghargaan menulis",
        "title": "Penghargaan Menulis",
        "phrases": [
          "Atas cerita yang kreatif serta tulisan yang penuh makna dan tersusun dengan baik.",
          "Atas kerja kerasmu membuat tulisan yang jelas, rapi, dan menarik."
        ],
        "suffix": ""
      },
      {
        "id": "sportsmanship",
        "label": "Sportivitas",
        "title": "Penghargaan Sportivitas",
        "phrases": [
          "Karena bermain jujur, menyemangati teman, dan menjadi rekan tim yang hebat.",
          "Karena menang dengan rendah hati, menerima kekalahan dengan senyuman, dan selalu berusaha sebaik mungkin."
        ],
        "suffix": ""
      },
      {
        "id": "artist",
        "label": "Penghargaan seniman",
        "title": "Penghargaan Seniman Cilik",
        "phrases": [
          "Atas karya seni penuh warna dan imajinasi yang membuat kami tersenyum.",
          "Atas kreativitas dan ketelitian dalam setiap karya yang kamu buat."
        ],
        "suffix": ""
      },
      {
        "id": "attitude",
        "label": "Sikap positif",
        "title": "Sikap Positif",
        "phrases": [
          "Atas senyum ceria dan semangat pantang menyerah setiap hari.",
          "Karena selalu bersikap positif dan membantu teman lain melakukan hal yang sama."
        ],
        "suffix": ""
      },
      {
        "id": "listener",
        "label": "Pendengar yang baik",
        "title": "Pendengar yang Baik",
        "phrases": [
          "Karena menyimak dengan saksama dan mengikuti arahan setiap hari.",
          "Karena mendengarkan orang lain dengan penuh kesabaran dan rasa hormat."
        ],
        "suffix": ""
      },
      {
        "id": "teamwork",
        "label": "Kompak dalam tim",
        "title": "Rekan Tim Terbaik",
        "phrases": [
          "Karena bekerja sama dengan baik dan membantu kelompokmu berhasil.",
          "Karena mau berbagi ide, bergantian, dan mendengarkan teman satu tim."
        ],
        "suffix": ""
      },
      {
        "id": "eco",
        "label": "Pahlawan lingkungan",
        "title": "Pahlawan Lingkungan",
        "phrases": [
          "Karena peduli pada bumi dengan mendaur ulang, menghemat energi, dan menjaga sekolah tetap hijau.",
          "Karena membantu menjaga kelas dan sekolah kita tetap bersih dan asri."
        ],
        "suffix": ""
      }
    ],
    "thanks": [
      {
        "id": "volunteer",
        "label": "Relawan kelas",
        "title": "Terima Kasih",
        "phrases": [
          "Karena telah meluangkan waktu dengan murah hati untuk membantu di kelas kami. Kami sangat terbantu oleh kehadiran Anda!",
          "Atas waktu, tenaga, dan kebaikan Anda sepanjang tahun ajaran ini."
        ],
        "suffix": ""
      },
      {
        "id": "parent",
        "label": "Orang tua pendamping",
        "title": "Terima Kasih",
        "phrases": [
          "Atas segala bantuan Anda di kelas kami dan dukungan Anda bagi setiap anak.",
          "Karena telah bekerja bersama kami tahun ini untuk membantu para siswa berkembang."
        ],
        "suffix": ""
      },
      {
        "id": "room-parent",
        "label": "Koordinator orang tua kelas",
        "title": "Terima Kasih",
        "phrases": [
          "Karena telah mengoordinasikan acara, kegiatan, dan banyak hal lainnya untuk kelas kita tahun ini.",
          "Karena telah menjaga komunikasi antarkeluarga siswa tetap erat dan membuat acara kelas berjalan lancar."
        ],
        "suffix": ""
      },
      {
        "id": "speaker",
        "label": "Pembicara tamu",
        "title": "Terima Kasih",
        "phrases": [
          "Karena telah mengunjungi kelas kami serta berbagi ilmu dan pengalaman bersama kami.",
          "Atas kunjungan yang menginspirasi sehingga membuat semua siswa antusias dan aktif bertanya."
        ],
        "suffix": ""
      },
      {
        "id": "aide",
        "label": "Asisten kelas",
        "title": "Terima Kasih",
        "phrases": [
          "Atas kesabaran, perhatian, dan kerja keras Anda bersama para siswa setiap hari.",
          "Atas segala bentuk dukungan Anda bagi kegiatan belajar dan kelas kami."
        ],
        "suffix": ""
      },
      {
        "id": "chaperone",
        "label": "Pendamping karya wisata",
        "title": "Terima Kasih",
        "phrases": [
          "Karena telah membantu menjaga semua siswa tetap aman dan gembira selama karya wisata.",
          "Karena telah ikut dalam petualangan kami dan menjadikannya hari yang tak terlupakan."
        ],
        "suffix": ""
      },
      {
        "id": "donation",
        "label": "Donatur dermawan",
        "title": "Terima Kasih",
        "phrases": [
          "Atas sumbangan buku dan perlengkapan yang sangat bermanfaat bagi kelas kami.",
          "Atas kebaikan hati Anda dalam mendukung kelas kami dan memberi para siswa lebih banyak sarana untuk bereksplorasi."
        ],
        "suffix": ""
      },
      {
        "id": "student-teacher",
        "label": "Mahasiswa PPL / Guru magang",
        "title": "Terima Kasih",
        "phrases": [
          "Karena telah membawa semangat, kreativitas, dan perhatian ke kelas kami.",
          "Atas kerja keras dan dedikasi Anda. Para siswa sangat senang belajar bersama Anda!"
        ],
        "suffix": ""
      },
      {
        "id": "class-helper",
        "label": "Piket kelas",
        "title": "Terima Kasih",
        "phrases": [
          "Karena selalu membantu guru dan teman sekelas setiap hari tanpa diminta.",
          "Karena menjadi penolong yang dapat diandalkan sehingga kegiatan kelas berjalan lancar."
        ],
        "suffix": ""
      }
    ],
    "closings": {
      "award": "Pertahankan kerja hebatmu!",
      "thanks": "Dengan ucapan terima kasih yang tulus."
    },
    "labels": {
      "award": "Piagam Penghargaan",
      "thanks": "Piagam Penghargaan"
    },
    "awardTitle": "Piagam Penghargaan",
    "suffixes": [],
    "signers": [
      "Guru",
      "Kepala Sekolah",
      ""
    ],
    "dateStyles": [
      "ad",
      "blank"
    ],
    "papers": [
      "a4",
      "letter"
    ],
    "limits": {
      "title": 30,
      "phrase": 120,
      "field": 40
    },
    "defaults": {
      "kind": "award",
      "preset": {
        "award": "star",
        "thanks": "volunteer"
      },
      "customTitle": "",
      "phrase": 0,
      "customPhrase": "",
      "suffix": null,
      "template": "forest",
      "nameStyle": "blank",
      "school": "",
      "className": "",
      "signer": "Guru",
      "teacher": "",
      "dateStyle": "ad",
      "date": "",
      "closing": true,
      "paper": "a4"
    }
  },
  "charades": [
    {
      "id": "animals",
      "name": "Hewan",
      "easy": [
        "kucing",
        "anjing",
        "kelinci",
        "monyet",
        "gajah",
        "jerapah",
        "singa",
        "harimau",
        "penguin",
        "kanguru",
        "katak",
        "ular",
        "buaya",
        "kura-kura",
        "kepiting",
        "burung",
        "ayam",
        "bebek",
        "babi",
        "sapi",
        "kuda",
        "domba",
        "beruang",
        "kupu-kupu",
        "lebah",
        "ikan mas",
        "gurita",
        "paus",
        "tikus",
        "burung hantu",
        "siput",
        "laba-laba",
        "dinosaurus",
        "zebra"
      ],
      "hard": [
        "burung merak",
        "unta",
        "badak",
        "burung pelatuk",
        "bunglon",
        "lumba-lumba",
        "hiu",
        "semut",
        "nyamuk",
        "kelelawar",
        "anjing laut",
        "ubur-ubur",
        "flamingo",
        "landak",
        "kungkang",
        "tupai",
        "gorila",
        "elang",
        "ulat"
      ]
    },
    {
      "id": "jobs",
      "name": "Pekerjaan",
      "easy": [
        "guru",
        "dokter",
        "perawat",
        "polisi",
        "pemadam kebakaran",
        "koki",
        "petani",
        "tukang pos",
        "penata rambut",
        "pelukis",
        "penyanyi",
        "pesulap",
        "astronot",
        "pilot",
        "dokter gigi",
        "dokter hewan",
        "sopir bus",
        "penjaga pantai",
        "pembuat roti",
        "fotografer",
        "badut",
        "penari",
        "montir",
        "kasir",
        "tukang bangunan",
        "penjaga kebun binatang",
        "pustakawan",
        "tukang kebun",
        "petugas penyeberangan jalan"
      ],
      "hard": [
        "wartawan",
        "pengacara",
        "hakim",
        "ilmuwan",
        "arkeolog",
        "insinyur",
        "tukang kayu",
        "penjahit",
        "pembawa berita",
        "pemandu wisata",
        "pramugari",
        "konduktor orkestra",
        "tukang ledeng",
        "kapten kapal",
        "penemu",
        "pematung",
        "sutradara film",
        "penulis buku",
        "peramal cuaca",
        "detektif",
        "dokter bedah"
      ]
    },
    {
      "id": "sports",
      "name": "Olahraga & Permainan",
      "easy": [
        "berlari",
        "berenang",
        "lompat tali",
        "bola basket",
        "sepak bola",
        "bisbol",
        "bola voli",
        "tenis meja",
        "bulu tangkis",
        "bermain papan luncur",
        "bersepeda",
        "seluncur es",
        "tarik tambang",
        "lompat tinggi",
        "lompat jauh",
        "mendaki gunung",
        "senam lantai",
        "hula hoop",
        "boling",
        "tenis",
        "loncat indah",
        "berselancar",
        "bermain ski",
        "lempar bola",
        "push-up",
        "engklek",
        "kejar-kejaran",
        "petak umpet",
        "karate",
        "rebut kursi"
      ],
      "hard": [
        "angkat besi",
        "anggar",
        "golf",
        "dayung",
        "lompat galah",
        "tolak peluru",
        "lempar lembing",
        "lari gawang",
        "gulat sumo",
        "judo",
        "panjat tebing",
        "seluncur indah",
        "lari maraton",
        "gantole",
        "bermain kayak",
        "sit-up",
        "yoga",
        "papan seluncur salju",
        "panahan",
        "lari estafet"
      ]
    },
    {
      "id": "food",
      "name": "Makanan",
      "easy": [
        "apel",
        "pisang",
        "semangka",
        "anggur",
        "nanas",
        "stroberi",
        "es krim",
        "kue ulang tahun",
        "burger",
        "kentang goreng",
        "piza",
        "roti tawar",
        "roti lapis",
        "spageti",
        "telur mata sapi",
        "jagung rebus",
        "permen lolipop",
        "berondong jagung",
        "hot dog",
        "kue kering",
        "susu",
        "harum manis",
        "cokelat",
        "jeruk",
        "wortel",
        "keju",
        "panekuk",
        "sereal",
        "taco",
        "sup"
      ],
      "hard": [
        "sushi",
        "brokoli",
        "pretzel",
        "burrito",
        "es limun",
        "selai kacang",
        "kue mangkuk",
        "wafel",
        "minuman smoothie",
        "salad sayur",
        "mi",
        "pangsit",
        "kelapa",
        "alpukat",
        "acar timun",
        "mangga",
        "marshmallow",
        "permen karet",
        "cabai",
        "bakso"
      ]
    },
    {
      "id": "actions",
      "name": "Tindakan",
      "easy": [
        "menyikat gigi",
        "mencuci muka",
        "mandi",
        "tidur",
        "makan",
        "minum air",
        "memakai baju",
        "mengikat tali sepatu",
        "menyisir rambut",
        "menguap",
        "bersin",
        "bertepuk tangan",
        "melambaikan tangan",
        "melompat",
        "merangkak",
        "naik tangga",
        "menari",
        "bernyanyi",
        "tertawa",
        "menangis",
        "meniup gelembung sabun",
        "bermain layang-layang",
        "menyiram tanaman",
        "mengajak anjing jalan-jalan",
        "membaca buku",
        "memotret",
        "membuka pintu",
        "menyapu lantai",
        "mencuci piring",
        "memeluk"
      ],
      "hard": [
        "memakai kaus kaki",
        "membuang ingus",
        "memotong kuku",
        "menyetrika pakaian",
        "membalik panekuk",
        "mengeringkan rambut",
        "melipat pakaian",
        "memakai dasi",
        "naik lift",
        "menyeberang jalan",
        "mengangkat kotak berat",
        "mencari kunci",
        "digigit nyamuk",
        "menginjak permen karet",
        "swafoto",
        "merenggangkan badan",
        "melempar tangkap bola",
        "berjinjit",
        "menggigil",
        "merajut",
        "mengecat tembok"
      ]
    },
    {
      "id": "school",
      "name": "Di Sekolah",
      "easy": [
        "pensil",
        "penghapus",
        "tas ransel",
        "gunting",
        "lem batang",
        "krayon",
        "penggaris",
        "meja belajar",
        "papan tulis",
        "buku tulis",
        "kotak bekal",
        "botol minum",
        "jam istirahat",
        "mengangkat tangan",
        "berbaris",
        "pekerjaan rumah",
        "ulangan mengeja",
        "jam makan siang",
        "perosotan",
        "ayunan",
        "jungkat-jungkit",
        "meraut pensil",
        "taman bermain",
        "presentasi benda di kelas",
        "waktu mendongeng",
        "kuas lukis",
        "kotak pensil",
        "bus sekolah",
        "panjatan besi"
      ],
      "hard": [
        "mikroskop",
        "bola dunia",
        "kalkulator",
        "percobaan sains",
        "kamus",
        "tabel perkalian",
        "latihan kebakaran",
        "karya wisata",
        "pentas drama sekolah",
        "wisuda sekolah",
        "foto kelas",
        "pekan olahraga",
        "kartu perpustakaan",
        "papan pengumuman",
        "stapler",
        "stabilo",
        "kartu izin keluar kelas",
        "lomba mengeja",
        "pameran buku"
      ]
    },
    {
      "id": "home",
      "name": "Benda di Rumah",
      "easy": [
        "tempat tidur",
        "bantal",
        "selimut",
        "sofa",
        "meja makan",
        "kursi",
        "lampu meja",
        "jendela",
        "bak mandi",
        "sikat gigi",
        "handuk",
        "sabun",
        "cermin",
        "televisi",
        "kulkas",
        "oven",
        "jam dinding",
        "telepon",
        "cangkir",
        "sendok",
        "garpu",
        "piring",
        "boneka beruang",
        "sapu",
        "tempat sampah",
        "mesin cuci",
        "payung",
        "bebek karet",
        "wastafel",
        "kunci"
      ],
      "hard": [
        "penyedot debu",
        "microwave",
        "pemanggang roti",
        "bel pintu",
        "kipas angin gantung",
        "rak buku",
        "keranjang cucian",
        "mesin pencuci piring",
        "jam weker",
        "pengering rambut",
        "blender",
        "remot TV",
        "tempat tidur tingkat",
        "senter",
        "gantungan baju",
        "kotak surat",
        "sakelar lampu",
        "alarm asap"
      ]
    },
    {
      "id": "places",
      "name": "Tempat",
      "easy": [
        "taman kota",
        "pantai",
        "kebun binatang",
        "peternakan",
        "perpustakaan",
        "rumah sakit",
        "supermarket",
        "bandara",
        "stasiun kereta",
        "toko roti",
        "kolam renang",
        "hutan",
        "gunung",
        "sungai",
        "istana",
        "museum",
        "restoran",
        "kantor pemadam kebakaran",
        "toko hewan peliharaan",
        "toko mainan",
        "halte bus",
        "kebun bunga",
        "padang pasir",
        "pulau",
        "hutan rimba",
        "gua",
        "sirkus",
        "bioskop"
      ],
      "hard": [
        "akuarium raksasa",
        "bank",
        "kantor pos",
        "salon rambut",
        "klinik dokter gigi",
        "tempat bermain boling",
        "taman hiburan",
        "gunung berapi",
        "mercusuar",
        "gedung pencakar langit",
        "tempat perkemahan",
        "air terjun",
        "proyek bangunan",
        "tempat binatu",
        "pom bensin",
        "pasar petani",
        "stasiun luar angkasa",
        "rumah hantu",
        "iglo"
      ]
    },
    {
      "id": "feelings",
      "name": "Perasaan",
      "easy": [
        "senang",
        "sedih",
        "marah",
        "takut",
        "terkejut",
        "lelah",
        "mengantuk",
        "lapar",
        "haus",
        "bersemangat",
        "bosan",
        "malu-malu",
        "konyol",
        "bangga",
        "kedinginan",
        "kepanasan",
        "sakit",
        "kesal",
        "khawatir",
        "berani",
        "tenang",
        "kesepian",
        "nyaman",
        "pusing",
        "bingung",
        "geli"
      ],
      "hard": [
        "gugup",
        "menahan malu",
        "frustrasi",
        "iri",
        "kecewa",
        "penasaran",
        "lega",
        "bersyukur",
        "tidak sabar",
        "percaya diri",
        "jijik",
        "kaget sekali",
        "penuh harapan",
        "keras kepala",
        "mengendap-endap",
        "sangat kelelahan",
        "bertekad kuat",
        "heran"
      ]
    },
    {
      "id": "seasons",
      "name": "Liburan & Musim",
      "easy": [
        "pesta ulang tahun",
        "meniup lilin",
        "membuka kado",
        "kembang api",
        "boneka salju",
        "perang bola salju",
        "meluncur di salju",
        "menyapu daun kering",
        "melompat di genangan air",
        "pelangi",
        "kacamata hitam",
        "istana pasir",
        "es loli",
        "piknik",
        "menanam benih",
        "labu",
        "pesta kostum",
        "pawai",
        "cokelat panas",
        "sarung tangan tebal",
        "syal leher",
        "tabir surya",
        "badai petir",
        "bola pantai",
        "berkemah",
        "daun berguguran"
      ],
      "hard": [
        "hitung mundur Tahun Baru",
        "keliling meminta permen",
        "mengukir labu",
        "memetik apel",
        "membungkus kado",
        "membuat permohonan",
        "kerja bakti membersihkan rumah",
        "liburan musim panas",
        "cuaca sangat panas",
        "badai salju",
        "hujan es",
        "festival musim gugur",
        "acara kumpul keluarga",
        "libur karena salju",
        "rumah kue jahe",
        "mencari telur Paskah",
        "kembang api kawat",
        "naik kereta jerami",
        "kedai es limun"
      ]
    }
  ],
  "grades": [
    {
      "label": "PAUD / TK (Prasekolah)",
      "options": [
        {
          "value": "k1",
          "label": "Kelompok Bermain (Usia 3–4)"
        },
        {
          "value": "k2",
          "label": "TK A (Usia 4–5)"
        },
        {
          "value": "k3",
          "label": "TK B (Usia 5–6)"
        }
      ]
    },
    {
      "label": "Sekolah Dasar (SD / MI)",
      "options": [
        {
          "value": "g1",
          "label": "Kelas 1 SD"
        },
        {
          "value": "g2",
          "label": "Kelas 2 SD"
        },
        {
          "value": "g3",
          "label": "Kelas 3 SD"
        },
        {
          "value": "g4",
          "label": "Kelas 4 SD"
        },
        {
          "value": "g5",
          "label": "Kelas 5 SD"
        },
        {
          "value": "g6",
          "label": "Kelas 6 SD"
        }
      ]
    },
    {
      "label": "Sekolah Menengah Pertama (SMP / MTs)",
      "options": [
        {
          "value": "g7",
          "label": "Kelas 7 SMP"
        },
        {
          "value": "g8",
          "label": "Kelas 8 SMP"
        },
        {
          "value": "g9",
          "label": "Kelas 9 SMP"
        }
      ]
    },
    {
      "label": "Sekolah Menengah Atas (SMA / SMK / MA)",
      "options": [
        {
          "value": "g10",
          "label": "Kelas 10 SMA/SMK"
        },
        {
          "value": "g11",
          "label": "Kelas 11 SMA/SMK"
        },
        {
          "value": "g12",
          "label": "Kelas 12 SMA/SMK"
        }
      ]
    },
    {
      "label": "Lainnya & Pendidikan Nonformal",
      "options": [
        {
          "value": "mixed",
          "label": "Lintas Usia / Bimbel & Ekskul"
        },
        {
          "value": "adult",
          "label": "Perguruan Tinggi / Dewasa"
        },
        {
          "value": "other",
          "label": "Lainnya / Umum"
        }
      ]
    }
  ],
  "comments": {
    "traits": {
      "focus": {
        "kw": "sikap menyimak dengan saksama di kelas",
        "lines": [
          "{N} menyimak dengan penuh perhatian di kelas dan mengikuti setiap pelajaran dengan saksama.",
          "{○○ adalah|Kamu adalah} pembelajar yang fokus dan tetap berkonsentrasi pada tugas selama pelajaran.",
          "Selama pelajaran berlangsung, {N} memperhatikan pembicara dan langsung memahami instruksi sejak pertama kali disampaikan.",
          "Kemampuan berkonsentrasi {N} membantu {○○|kamu} mempelajari materi baru dengan cepat.",
          "Meskipun suasana kelas sedang ramai, {N} tetap fokus pada tugas yang sedang dikerjakan.",
          "{○○ menyimak|Kamu menyimak} instruksi dengan cermat dan langsung mulai mengerjakan tanpa menunda."
        ]
      },
      "effort": {
        "kw": "semangat kerja yang tinggi",
        "lines": [
          "{N} mencurahkan usaha sungguh-sungguh pada setiap tugas dan bangga menyelesaikan pekerjaan dengan baik.",
          "{○○ telah|Kamu telah} menunjukkan semangat kerja yang tinggi sepanjang semester ini.",
          "{N} memberikan usaha terbaik untuk setiap tugas, baik yang mudah maupun yang sulit.",
          "Kerja keras adalah salah satu kelebihan terbesar {N}.",
          "{○○ bersedia|Kamu bersedia} meluangkan waktu yang dibutuhkan untuk menyelesaikan pekerjaan dengan baik.",
          "Terlihat jelas bahwa {○○ menanggapi|kamu menanggapi} kegiatan belajar dengan serius dan selalu berusaha memberikan yang terbaik dari diri {○○|kamu}."
        ]
      },
      "homework": {
        "kw": "PR yang rapi dan lengkap",
        "lines": [
          "{N} secara konsisten mengumpulkan PR yang lengkap, rapi, dan tepat waktu.",
          "Tugas-tugas {N} menunjukkan kesungguhan dan perhatian terhadap detail.",
          "PR dikumpulkan tepat waktu dan dikerjakan dengan penuh kesungguhan.",
          "{N} menyelesaikan tugas secara tuntas dan menyajikannya dengan rapi.",
          "{○○ mengerjakan|Kamu mengerjakan} PR dengan sungguh-sungguh, dan hal itu terlihat dari kualitas hasil {kerjanya|kerjamu}.",
          "PR {N} selalu rapi, lengkap, dan dikerjakan dengan matang."
        ]
      },
      "speak": {
        "kw": "partisipasi yang percaya diri",
        "lines": [
          "{N} berpartisipasi secara aktif dalam diskusi dan menyampaikan ide dengan percaya diri.",
          "{○○ selalu|Kamu selalu} bersedia mengangkat tangan dan berkontribusi dalam diskusi kelas.",
          "{N} sigap berbagi ide dan memberi banyak masukan berharga dalam perbincangan kelas.",
          "Diskusi kelas menjadi lebih hidup berkat kontribusi pemikiran {N} yang matang.",
          "{○○ berbicara|Kamu berbicara} dengan percaya diri dan mengembangkan ide-ide dari teman lainnya.",
          "Saat ada pertanyaan yang diajukan, {N} sering menjadi salah satu yang pertama menjawab."
        ]
      },
      "curious": {
        "kw": "rasa ingin tahu yang alami",
        "lines": [
          "{N} membawa rasa ingin tahu yang alami dalam belajar dan sering mengajukan pertanyaan yang berbobot.",
          "{○○ bersemangat|Kamu bersemangat} mengeksplorasi ide-ide baru dan memahami cara kerja berbagai hal.",
          "Rasa ingin tahu {N} melahirkan pertanyaan-pertanyaan bagus yang membantu seluruh kelas berpikir lebih mendalam.",
          "{N} senang mencari tahu mengapa sesuatu terjadi dan bagaimana cara kerjanya.",
          "Topik-topik baru memicu minat {N}, dan {○○ selalu|kamu selalu} antusias untuk mempelajari lebih lanjut.",
          "{○○ mengajukan|Kamu mengajukan} pertanyaan yang menunjukkan pemikiran mendalam dan keinginan kuat untuk memahami materi."
        ]
      },
      "reading": {
        "kw": "kegemaran membaca",
        "lines": [
          "{N} memiliki kegemaran membaca yang tulus dan sering terlihat memegang buku.",
          "Kebiasaan membaca {N} telah membantu membangun kosakata yang kaya dan wawasan yang luas.",
          "{N} membaca beragam bacaan dan senang menceritakan buku-buku {favoritnya|favoritmu}.",
          "Waktu membaca jelas menjadi salah satu momen paling menyenangkan dalam keseharian {N}.",
          "{○○ memilih|Kamu memilih} buku dengan antusias serta membaca dengan kelancaran dan pemahaman yang terus berkembang.",
          "Kecintaan pada buku tercermin dalam kosakata dan karya tulis {N}."
        ]
      },
      "careful": {
        "kw": "pekerjaan yang teliti dan akurat",
        "lines": [
          "{N} bekerja dengan teliti dan memeriksa kembali keakuratannya sebelum mengumpulkan tugas.",
          "{○○ memberikan|Kamu memberikan} perhatian penuh pada detail di setiap tugas.",
          "{N} meluangkan waktu untuk memastikan setiap detail sudah tepat dan jarang terburu-buru saat mengerjakan tugas.",
          "Hasil kerja {N} akurat, tuntas, dan disajikan dengan rapi.",
          "{○○ memeriksa|Kamu memeriksa} jawaban dengan cermat dan memperbaiki kekeliruan kecil sebelum mengumpulkan tugas.",
          "Ketelitian terhadap detail merupakan kelebihan nyata dalam pekerjaan sehari-hari {N}."
        ]
      },
      "selfdriven": {
        "kw": "kemandirian dan inisiatif",
        "lines": [
          "{N} mengambil inisiatif dalam belajar dan menyelesaikan tugas tanpa perlu diingatkan.",
          "{○○ adalah|Kamu adalah} pembelajar yang termotivasi dari diri sendiri dan selalu mencari cara untuk berkembang.",
          "{N} langsung mengerjakan tugas dan dapat bekerja dengan baik secara mandiri.",
          "{○○ menetapkan|Kamu menetapkan} tujuan pribadi dan berusaha secara konsisten untuk mencapainya.",
          "Tanpa diminta, {N} sering mencari cara untuk belajar lebih banyak.",
          "{○○ adalah|Kamu adalah} pembelajar yang termotivasi dan tidak perlu sering diingatkan agar tetap fokus."
        ]
      },
      "persist": {
        "kw": "ketekunan",
        "lines": [
          "{N} menunjukkan ketekunan yang luar biasa dan terus berusaha saat menghadapi tugas yang menantang.",
          "{○○ tidak|Kamu tidak} mudah menyerah dan bekerja keras untuk mengatasi kesulitan.",
          "{N} terus berusaha saat tugas terasa sulit dan menyelesaikannya hingga tuntas.",
          "Tantangan tidak membuat {○○|kamu} berkecil hati; sebaliknya, {○○ mencoba|kamu mencoba} lagi dengan pendekatan baru.",
          "Tekad {N} terlihat jelas setiap kali ada tugas yang membutuhkan usaha ekstra.",
          "{○○ telah|Kamu telah} belajar bahwa kesalahan adalah bagian dari proses belajar dan terus berusaha."
        ]
      },
      "kind": {
        "kw": "kebaikan hati",
        "lines": [
          "{N} menunjukkan kebaikan hati dan empati kepada orang lain.",
          "{○○ penuh|Kamu penuh} perhatian dan peduli, sehingga teman-teman sekelas merasa nyaman di dekat {○○|kamu}.",
          "{N} peka ketika orang lain membutuhkan penghiburan dan merespons dengan hangat.",
          "Sifat peduli {N} membuat teman-teman sekelas merasa dihargai dan aman.",
          "Tindakan-tindakan kecil penuh kebaikan sudah menjadi bagian alami dari keseharian {N}.",
          "{○○ memperlakukan|Kamu memperlakukan} orang lain dengan lembut dan memikirkan perasaan mereka."
        ]
      },
      "honest": {
        "kw": "kejujuran",
        "lines": [
          "{N} bersikap jujur dan bertanggung jawab atas kesalahan.",
          "{○○ telah|Kamu telah} mendapatkan kepercayaan dari guru dan teman sekelas melalui kejujuran.",
          "{N} mengatakan yang sebenarnya meskipun itu sulit dilakukan.",
          "Kejujuran {N} membuat {○○|kamu} menjadi sosok yang dapat dipercaya orang lain.",
          "{○○ berani|Kamu berani} mengakui kesalahan dan belajar darinya.",
          "Guru dan teman-teman sekelas tahu bahwa perkataan {N} dapat dipegang."
        ]
      },
      "polite": {
        "kw": "sopan santun",
        "lines": [
          "{N} bersikap sopan dan hormat kepada guru serta teman sekelas.",
          "Sopan santun dan keramahan {N} diperhatikan oleh semua orang di sekolah.",
          "{N} menggunakan kata-kata yang santun seperti tolong dan terima kasih tanpa perlu diingatkan.",
          "Sikap santun {N} memberikan kesan positif bagi semua orang.",
          "{○○ menyapa|Kamu menyapa} orang dewasa dan teman sekelas dengan hangat serta berbicara dengan sopan.",
          "Sopan santun tampak alami pada diri {○○|kamu}, baik di dalam kelas maupun di lingkungan sekolah."
        ]
      },
      "responsible": {
        "kw": "rasa tanggung jawab yang tinggi",
        "lines": [
          "{N} selalu dapat diandalkan untuk menyelesaikan tugas hingga tuntas.",
          "{○○ menjalankan|Kamu menjalankan} tanggung jawab dengan sungguh-sungguh dan menjadi anggota kelas yang dapat diandalkan.",
          "{N} menepati komitmen dan dapat dipercaya memegang tugas-tugas penting.",
          "Sikap {N} yang dapat diandalkan menjadi tumpuan guru dan teman sekelas.",
          "Saat diberi tugas, {N} menyelesaikannya dengan cermat hingga tuntas.",
          "{○○ bertanggung|Kamu bertanggung} jawab penuh atas tugas yang diberikan dan barang-barang pribadi."
        ]
      },
      "positive": {
        "kw": "sikap positif",
        "lines": [
          "{N} membawa sikap yang ceria dan positif ke kelas setiap hari.",
          "Sikap optimis dan keceriaan {N} mencerahkan suasana kelas.",
          "{N} menyambut setiap hari dengan senyuman dan semangat yang positif.",
          "Antusiasme {N} menular dan membangkitkan semangat seluruh kelas.",
          "Bahkan saat keadaan terasa sulit, {N} tetap ceria dan penuh harapan.",
          "{○○ membawa|Kamu membawa} kehangatan dan keceriaan ke kelas kita."
        ]
      },
      "confident": {
        "kw": "kepercayaan diri",
        "lines": [
          "{N} menghadapi tantangan baru dengan percaya diri.",
          "{○○ berani|Kamu berani} mencoba hal-hal baru dan tidak takut membuat kesalahan.",
          "{N} menghadapi tugas-tugas baru dengan sikap optimis.",
          "Kepercayaan diri {N} terlihat saat membagikan hasil kerja atau mencoba hal baru.",
          "{○○ senang|Kamu senang} menerima tantangan dan tidak menghindari pertanyaan sulit.",
          "{N} menghadapi situasi baru dengan tenang dan yakin pada diri sendiri."
        ]
      },
      "helpful": {
        "kw": "sikap suka menolong",
        "lines": [
          "{N} selalu siap membantu teman sekelas yang membutuhkan dukungan.",
          "{○○ sering|Kamu sering} mengulurkan tangan untuk membantu dan dengan sabar menjelaskan berbagai hal kepada teman lain.",
          "{N} peka saat ada teman yang kesulitan dan segera menawarkan bantuan.",
          "Kesediaan {N} untuk membantu membawa dampak nyata bagi teman-teman sekelas.",
          "Teman-teman sekelas sering meminta bantuan {○○|kamu}, dan {○○ selalu|kamu selalu} senang membantunya.",
          "{○○ membantu|Kamu membantu} orang lain tanpa diminta, dan selalu dengan senyuman."
        ]
      },
      "teamwork": {
        "kw": "kerja sama tim",
        "lines": [
          "{N} bekerja dengan baik dalam kelompok, mendengarkan pendapat teman, dan berbagi beban tugas.",
          "{○○ adalah|Kamu adalah} anggota tim yang kooperatif dan membantu kelompok mencapai keberhasilan.",
          "{N} menyumbangkan ide dalam kerja kelompok dan menghargai masukan dari teman lain.",
          "Dalam proyek kelompok, {N} membagi tugas secara adil dan menyemangati teman satu tim.",
          "Semangat kerja sama {N} membantu kelompok bekerja bersama dengan lancar.",
          "{○○ tahu|Kamu tahu} cara berkompromi demi keberhasilan seluruh tim."
        ]
      },
      "friendly": {
        "kw": "keramahan",
        "lines": [
          "{N} bergaul dengan baik bersama teman sekelas dan menjadi teman yang baik bagi banyak orang.",
          "{○○ ramah|Kamu ramah} dan merangkul semua teman, sehingga orang lain merasa diterima.",
          "{N} mudah berteman dan mengajak teman lain ikut dalam permainan maupun kegiatan.",
          "Sikap {N} yang hangat dan ramah membantu teman-teman sekelas merasa diterima.",
          "{○○ mudah|Kamu mudah} bergaul dan bersikap baik kepada semua orang.",
          "Teman-teman sekelas senang berada di dekat {N}, baik saat belajar maupun bermain."
        ]
      },
      "leader": {
        "kw": "kepemimpinan",
        "lines": [
          "{N} menunjukkan kemampuan kepemimpinan yang kuat dan memandu kerja kelompok dengan efektif.",
          "{○○ memiliki|Kamu memiliki} jiwa kepemimpinan alami yang dikagumi teman-teman sekelas.",
          "{N} memimpin tugas kelompok sambil tetap mendengarkan pendapat teman lain.",
          "Teman-teman sekelas menghargai ide-ide {N} dan senang bekerja bersama.",
          "{○○ mengatur|Kamu mengatur} kerja kelompok dengan baik dan memastikan setiap orang mendapat peran.",
          "Kepemimpinan {N} tenang, adil, dan memberi semangat."
        ]
      },
      "respect": {
        "kw": "sikap menghargai orang lain",
        "lines": [
          "{N} mendengarkan orang lain dengan penuh hormat dan menghargai perbedaan sudut pandang.",
          "{○○ memperlakukan|Kamu memperlakukan} semua orang dengan rasa hormat.",
          "{N} menunggu giliran untuk berbicara dan mendengarkan teman sekelas dengan saksama.",
          "Sikap hormat {N} membantu menciptakan suasana kelas yang positif.",
          "{○○ menerima|Kamu menerima} perbedaan dan berbicara kepada semua orang dengan sopan.",
          "Sikap menghargai orang lain terlihat jelas dari cara {○○ mendengarkan|kamu mendengarkan} dan merespons."
        ]
      },
      "share": {
        "kw": "kemurahan hati",
        "lines": [
          "{N} dengan murah hati berbagi ide dan perlengkapan dengan teman sekelas.",
          "{○○ senang berbagi apa yang telah ○○|Kamu senang berbagi apa yang telah kamu} pelajari dengan orang lain.",
          "{N} dengan senang hati berbagi perlengkapan belajar dan bergantian tanpa mengeluh.",
          "Kemurahan hati {N} dihargai oleh semua orang di kelas.",
          "{○○ sigap|Kamu sigap} berbagi ide dan sumber belajar saat kerja kelompok.",
          "Berbagi adalah hal yang alami bagi {○○|kamu}, baik itu perlengkapan, ide, maupun waktu."
        ]
      },
      "tidy": {
        "kw": "kerapian dan keteraturan",
        "lines": [
          "{○○ menjaga|Kamu menjaga} meja tetap rapi dan perlengkapan belajar tertata dengan baik.",
          "{○○ sangat|Kamu sangat} teratur dan selalu siap mengikuti pelajaran.",
          "Tempat kerja {N} selalu rapi, dan perlengkapan belajar mudah ditemukan.",
          "{N} menata buku serta perlengkapan dengan rapi dan merawatnya dengan baik.",
          "Setelah kegiatan selesai, {N} merapikan tempat dengan cepat dan meninggalkannya dalam keadaan bersih.",
          "Keteraturan yang baik membantu {○○|kamu} memulai setiap pelajaran dengan siap belajar."
        ]
      },
      "punctual": {
        "kw": "ketepatan waktu",
        "lines": [
          "{N} tiba tepat waktu setiap hari dan siap untuk belajar.",
          "{○○ mengatur|Kamu mengatur} waktu dengan baik dan menyelesaikan tugas sesuai tenggat.",
          "{N} selalu tepat waktu dan siap saat pelajaran dimulai.",
          "Ketepatan waktu {N} membantu {○○|kamu} memanfaatkan setiap hari sekolah dengan optimal.",
          "{○○ mengumpulkan|Kamu mengumpulkan} tugas tepat waktu dan memanfaatkan waktu dengan baik.",
          "Datang tepat waktu dengan persiapan lengkap adalah kebiasaan yang jelas telah {○○ kuasai|kamu kuasai}."
        ]
      },
      "rules": {
        "kw": "disiplin diri",
        "lines": [
          "{N} mengikuti rutinitas kelas dan memberikan teladan yang baik bagi teman lain.",
          "{○○ menunjukkan|Kamu menunjukkan} disiplin diri yang sangat baik dan menghormati peraturan kelas.",
          "{N} memahami aturan kelas dan mematuhinya secara konsisten.",
          "Perilaku {N} yang tenang dan bijaksana menjadi teladan bagi teman lain.",
          "{○○ membuat|Kamu membuat} pilihan yang baik, bahkan saat tidak ada orang dewasa yang mengawasi.",
          "Rutinitas kelas berjalan lancar berkat bantuan dan kerja sama {N}."
        ]
      },
      "independent": {
        "kw": "kemandirian",
        "lines": [
          "{N} menjalani rutinitas harian secara mandiri.",
          "{○○ mengurus|Kamu mengurus} barang-barang pribadi dan tugas tanpa bantuan.",
          "{N} menjaga barang-barang pribadi dan bersiap untuk setiap pelajaran tanpa bantuan.",
          "Kemandirian {N} dalam menjalani rutinitas sehari-hari sangat mengesankan.",
          "{○○ menangani|Kamu menangani} tugas harian dengan percaya diri dan hanya meminta bantuan saat diperlukan.",
          "Merapikan barang dan berpindah antarkegiatan dapat {○○ lakukan|kamu lakukan} dengan mudah."
        ]
      },
      "cleaning": {
        "kw": "kerajinan dalam piket kelas",
        "lines": [
          "{N} menjalankan tugas piket kebersihan dengan sungguh-sungguh dan membuat area {tugasnya|tugasmu} bersih berkilau.",
          "{○○ bekerja|Kamu bekerja} dengan rajin saat waktu bersih-bersih.",
          "{N} bekerja keras saat waktu bersih-bersih dan memperhatikan setiap sudut.",
          "Tugas kebersihan {N} selalu dikerjakan secara menyeluruh dan tanpa mengeluh.",
          "{○○ bangga|Kamu bangga} menjaga kelas kita tetap bersih dan rapi.",
          "Saat waktu bersih-bersih, {N} dapat diandalkan untuk menyelesaikan tugas dengan baik."
        ]
      },
      "cadre": {
        "kw": "ketekunan menjalankan tugas pengurus kelas",
        "lines": [
          "{N} menjalankan tugas membantu di kelas dengan cermat dan dapat diandalkan.",
          "Sebagai petugas kelas, {○○ memberikan|kamu memberikan} teladan yang baik dan membantu guru.",
          "{N} menjalankan tanggung jawab sebagai petugas kelas dengan dewasa dan penuh perhatian.",
          "Kerja {N} yang dapat diandalkan sebagai petugas kelas sangat membantu semua orang.",
          "{○○ menjalankan|Kamu menjalankan} tugas membantu di kelas tanpa perlu diingatkan dan memberikan teladan yang baik.",
          "Dalam peran membantu di kelas, {N} dapat diandalkan, teratur, dan adil."
        ]
      },
      "service": {
        "kw": "semangat melayani",
        "lines": [
          "{N} dengan sukarela membantu tugas-tugas kelas dan mengerjakannya dengan sungguh-sungguh.",
          "{○○ selalu|Kamu selalu} siap turun tangan agar kegiatan kelas kita berjalan lancar.",
          "{N} sigap mengajukan diri saat ada pekerjaan yang perlu dilakukan.",
          "Kesediaan {N} untuk ikut membantu sangat dihargai oleh semua orang.",
          "{○○ menawarkan|Kamu menawarkan} diri untuk membantu tugas kelas dan menyelesaikannya dengan cermat.",
          "Setiap kali bantuan dibutuhkan, {N} menjadi salah satu yang pertama maju."
        ]
      },
      "sports": {
        "kw": "kemampuan olahraga",
        "lines": [
          "{N} unggul dalam pendidikan jasmani dan menunjukkan sportivitas yang tinggi.",
          "{○○ membawa|Kamu membawa} energi dan semangat kebersamaan dalam kegiatan olahraga.",
          "{N} bermain dengan penuh semangat dan terampil saat pelajaran olahraga serta menyemangati teman satu tim.",
          "Koordinasi gerak dan kebugaran {N} menonjol dalam aktivitas fisik.",
          "{○○ bermain|Kamu bermain} secara jujur, mematuhi aturan, dan tetap sportif dalam setiap permainan.",
          "Pendidikan jasmani jelas merupakan keunggulan, dan {N} mengikuti setiap kegiatan dengan usaha penuh."
        ]
      },
      "art": {
        "kw": "bakat seni",
        "lines": [
          "{N} memiliki bakat nyata di bidang seni, dengan karya yang kreatif dan penuh warna.",
          "Karya seni {N} menunjukkan imajinasi dan ketelitian.",
          "{N} menggunakan warna dan detail dengan cermat dalam karya {seninya|senimu}.",
          "Proyek seni {N} orisinal dan diselesaikan dengan rapi.",
          "{○○ mengerjakan|Kamu mengerjakan} kegiatan seni dengan penuh imajinasi dan keberanian untuk bereksperimen.",
          "Kreativitas terpancar dalam setiap karya seni yang {dibuat ○○|kamu buat}."
        ]
      },
      "music": {
        "kw": "bakat musik",
        "lines": [
          "{N} menunjukkan bakat musik yang nyata dan berpartisipasi dengan antusias.",
          "{○○ memiliki|Kamu memiliki} kepekaan musik yang baik serta senang bernyanyi dan bermain musik.",
          "{N} bernyanyi dengan percaya diri dan menjaga ketukan yang stabil.",
          "Antusiasme {N} terhadap musik memberi semangat pada pelajaran kami.",
          "{○○ dapat|Kamu dapat} menguasai lagu dan irama baru dengan cepat.",
          "Musik jelas merupakan kegemaran {○○|kamu}, dan {N} berpartisipasi dengan penuh sukacita."
        ]
      },
      "writing": {
        "kw": "kemampuan menulis yang kuat",
        "lines": [
          "{N} menulis dengan jelas dan penuh imajinasi.",
          "Tulisan {N} tersusun rapi dan menunjukkan kosakata yang kaya.",
          "{N} menggunakan pilihan kata yang menarik dan struktur yang jelas dalam tugas tertulis.",
          "Cerita karya {N} penuh imajinasi dan menyenangkan untuk dibaca.",
          "{○○ mengungkapkan|Kamu mengungkapkan} ide dalam tulisan dengan keterampilan dan detail yang terus berkembang.",
          "Menulis adalah keunggulan nyata, dan {N} senang merangkai cerita serta penjelasan."
        ]
      },
      "creative": {
        "kw": "kreativitas",
        "lines": [
          "{N} membawa ide-ide kreatif ke dalam proyek dan menyukai kegiatan praktik langsung.",
          "{○○ berpikir|Kamu berpikir} kreatif dan menemukan solusi orisinal untuk berbagai masalah.",
          "{N} mencetuskan ide-ide orisinal serta senang merakit dan membuat karya.",
          "Imajinasi {N} menghadirkan ide-ide segar dalam proyek kelas.",
          "{○○ senang|Kamu senang} bereksperimen dan menemukan cara-cara kreatif untuk memecahkan masalah.",
          "Proyek praktik langsung memunculkan kreativitas dan kecerdikan {N}."
        ]
      },
      "stage": {
        "kw": "keterampilan berbicara yang jelas",
        "lines": [
          "{N} berbicara dengan jelas dan percaya diri di depan kelas.",
          "{○○ adalah|Kamu adalah} pembicara yang ekspresif dan mampu memikat pendengar.",
          "{N} melakukan presentasi di depan kelas dengan suara yang jelas dan kontak mata yang baik.",
          "Presentasi {N} dipersiapkan dengan matang dan menarik.",
          "{○○ berbicara|Kamu berbicara} dengan percaya diri di depan pendengar dan menjelaskan ide dengan jelas.",
          "Berbicara di depan orang lain mengalir begitu alami bagi {○○|kamu}."
        ]
      },
      "logic": {
        "kw": "pemikiran logis",
        "lines": [
          "{N} berpikir secara logis dan memecahkan masalah dengan lebih dari satu cara.",
          "{○○ menyukai|Kamu menyukai} soal-soal yang menantang dan bernalar dengan jelas.",
          "{N} menguraikan masalah langkah demi langkah dan menjelaskan {penalarannya|penalaranmu} dengan jelas.",
          "Pemikiran logis {N} menonjol saat mengerjakan teka-teki dan tugas yang menantang.",
          "{○○ mengenali|Kamu mengenali} pola dengan cepat dan menggunakannya untuk menemukan solusi.",
          "Bernalar untuk menjawab pertanyaan rumit adalah salah satu kekuatan utama {N}."
        ]
      },
      "prog_study": {
        "kw": "kemajuan akademik yang nyata",
        "lines": [
          "{N} telah membuat kemajuan akademik yang sangat baik pada semester ini.",
          "Kerja keras {N} membuahkan hasil berupa peningkatan yang stabil dan nyata.",
          "Hasil kerja {N} meningkat secara stabil di berbagai mata pelajaran pada semester ini.",
          "{N} telah berkembang pesat sebagai pembelajar selama beberapa bulan terakhir.",
          "Kemajuan yang {○○ capai|kamu capai} di kelas pada semester ini terlihat sangat jelas.",
          "{○○ telah|Kamu telah} membangun keterampilan yang lebih kuat dan kini berhasil menyelesaikan tugas yang lebih sulit."
        ]
      },
      "prog_confidence": {
        "kw": "kepercayaan diri yang terus tumbuh",
        "lines": [
          "Kepercayaan diri {N} telah berkembang dan kini lebih sigap menyampaikan ide.",
          "Sungguh menyenangkan melihat {○○|kamu} menjadi lebih percaya diri pada semester ini.",
          "{N} kini berpartisipasi di kelas dengan lebih bersemangat dibandingkan pada awal semester.",
          "Rasa percaya diri {N} yang terus tumbuh terlihat dari cara {○○ mencoba|kamu mencoba} hal-hal baru.",
          "{○○ menjadi|Kamu menjadi} lebih berani berbicara dan menyampaikan ide.",
          "Kepercayaan diri yang baru terlihat jelas dalam hasil kerja dan partisipasi {N}."
        ]
      },
      "prog_habit": {
        "kw": "kebiasaan harian yang lebih baik",
        "lines": [
          "{N} telah membuat kemajuan besar dalam mengikuti rutinitas dan mengelola perilaku secara mandiri.",
          "Fokus dan kebiasaan kerja {N} telah meningkat secara nyata.",
          "{N} kini mengikuti rutinitas harian dengan jauh lebih mandiri.",
          "Keteraturan dan kesiapan belajar {N} telah meningkat pesat.",
          "{○○ menjadi|Kamu menjadi} lebih tenang dan fokus selama pelajaran berlangsung.",
          "Kebiasaan yang lebih baik telah membantu {○○|kamu} mendapatkan hasil maksimal setiap hari di sekolah."
        ]
      },
      "prog_social": {
        "kw": "pertemanan yang lebih erat",
        "lines": [
          "{N} telah berkembang secara sosial dan kini bergaul dengan baik bersama teman-teman sekelas.",
          "{○○ telah|Kamu telah} belajar mengungkapkan perasaan dengan tenang dan bekerja sama dengan baik bersama orang lain.",
          "{N} kini bekerja lebih nyaman bersama teman sekelas, baik secara berpasangan maupun berkelompok.",
          "Kenyamanan {N} saat berinteraksi dengan berbagai teman sekelas telah berkembang sepanjang semester ini.",
          "{○○ menjadi|Kamu menjadi} lebih sabar dan penuh pengertian terhadap orang lain.",
          "Bergaul dengan teman sekelas menjadi jauh lebih mudah bagi {○○|kamu} pada semester ini."
        ]
      },
      "a_concept": {
        "kw": "pemahaman yang kuat tentang {c}",
        "lines": [
          "Dalam pelajaran {subj}, {N} menunjukkan pemahaman yang kuat tentang {c}.",
          "{N} menangkap konsep baru dalam pelajaran {subj} dengan cepat dan tepat.",
          "{N} memahami {c} dengan baik dan dapat menjelaskan gagasan utamanya.",
          "Pemahaman {N} tentang {c} sudah mantap dan terus berkembang.",
          "Saat muncul konsep baru dalam pelajaran {subj}, {N} menghubungkannya dengan apa yang sudah {diketahui ○○|kamu ketahui}.",
          "{○○ memiliki|Kamu memiliki} pemahaman yang jelas tentang konsep-konsep utama dalam pelajaran {subj}."
        ]
      },
      "a_skill": {
        "kw": "{k} yang penuh percaya diri",
        "lines": [
          "{N} menunjukkan keterampilan yang terus berkembang dalam {k}.",
          "Keterampilan {k} {N} kuat dan konsisten.",
          "{N} semakin percaya diri dalam {k}.",
          "Kemajuan {N} dalam {k} terlihat jelas di kelas.",
          "{N} mencurahkan usaha yang sungguh-sungguh dalam {k}.",
          "{N} menangani tugas-tugas yang berkaitan dengan {k} dengan semakin mudah."
        ]
      },
      "a_apply": {
        "kw": "penerapan hasil belajar",
        "lines": [
          "{N} menerapkan pembelajaran {subj} ke dalam situasi baru dengan mudah.",
          "{N} membuat hubungan yang baik antara pelajaran {subj} dan kehidupan sehari-hari.",
          "{N} menggunakan apa yang telah {dipelajari ○○|kamu pelajari} dalam {subj} untuk menyelesaikan tugas-tugas baru.",
          "{○○ dapat|Kamu dapat} mengambil konsep dari pelajaran {subj} dan menggunakannya dengan cara-cara baru.",
          "{N} sering mengaitkan apa yang dipelajari dalam {subj} dengan kehidupan nyata.",
          "{N} menerapkan keterampilan baru dari pelajaran {subj} secara praktis."
        ]
      },
      "a_express": {
        "kw": "penjelasan yang jelas",
        "lines": [
          "{N} menjelaskan ide dengan jelas selama diskusi {subj}.",
          "{N} membagikan ide dalam pelajaran {subj} dengan percaya diri.",
          "{N} mengomunikasikan ide dalam pelajaran {subj} dengan jelas, baik secara lisan maupun tertulis.",
          "{○○ membagikan|Kamu membagikan} pemikiran dalam pelajaran {subj} dan mendengarkan pandangan orang lain.",
          "Kontribusi {N} dalam diskusi {subj} penuh pemikiran dan jelas.",
          "Dalam pelajaran {subj}, {N} menggunakan kosakata yang tepat untuk mengungkapkan ide."
        ]
      },
      "a_explore": {
        "kw": "rasa ingin tahu yang mendalam",
        "lines": [
          "{N} mengajukan pertanyaan yang berbobot dan mengeksplorasi ide dalam pelajaran {subj}.",
          "{N} mencoba berbagai strategi saat memecahkan masalah.",
          "{N} senang menyelidiki pertanyaan dalam pelajaran {subj} dan mencari jawabannya.",
          "Rasa ingin tahu {N} dalam pelajaran {subj} melahirkan pertanyaan-pertanyaan yang berbobot.",
          "{○○ bersedia|Kamu bersedia} menguji ide dan belajar dari hasilnya.",
          "Dalam pelajaran {subj}, {N} berpikir dengan cermat dan melihat persoalan dari berbagai sudut pandang."
        ]
      },
      "a_work": {
        "kw": "{w} yang cermat",
        "lines": [
          "Hasil {w} {N} lengkap dan dikerjakan dengan cermat.",
          "{N} berusaha menyelesaikan {w} dengan teliti dan tuntas.",
          "{N} menyelesaikan {w} dengan rapi dan tepat waktu.",
          "Hasil {w} {N} menunjukkan ketelitian dan perhatian terhadap detail.",
          "{○○ bangga|Kamu bangga} menghasilkan {w} yang tuntas dan tersaji dengan baik.",
          "Hasil {w} yang {dikumpulkan ○○|kamu kumpulkan} selalu lengkap dan tersaji dengan rapi."
        ]
      },
      "a_engage": {
        "kw": "partisipasi yang antusias",
        "lines": [
          "{N} terlibat aktif dan antusias selama pelajaran {subj}.",
          "{N} menunjukkan minat yang sungguh-sungguh terhadap pelajaran {subj}.",
          "{N} berpartisipasi dengan penuh semangat dalam kegiatan {subj}.",
          "Antusiasme {N} terhadap pelajaran {subj} terlihat jelas di setiap pertemuan.",
          "{○○ mengikuti|Kamu mengikuti} pelajaran {subj} dengan penuh semangat dan sikap positif.",
          "{N} selalu menantikan pelajaran {subj} dan tetap terlibat aktif sepanjang kegiatan."
        ]
      },
      "a_improve": {
        "kw": "kemajuan yang stabil",
        "lines": [
          "{N} telah membuat kemajuan yang stabil dalam pelajaran {subj} pada semester ini.",
          "Hasil belajar {N} dalam {subj} terus meningkat.",
          "Keterampilan {N} dalam pelajaran {subj} telah berkembang secara stabil pada semester ini.",
          "{N} telah mencapai kemajuan nyata dalam pelajaran {subj} melalui usaha yang konsisten.",
          "Sepanjang semester ini, {○○ menjadi|kamu menjadi} lebih percaya diri dalam pelajaran {subj}.",
          "Setiap bulan, {N} mengembangkan pemahaman baru berdasarkan materi {subj} yang telah dipelajari sebelumnya."
        ]
      }
    },
    "wishes": {
      "w_focus": [
        "Langkah selanjutnya bagi {○○|kamu} adalah tetap fokus selama pelajaran berlangsung, yang akan membuat proses belajar menjadi lebih bermakna.",
        "Saya mendorong {○○|kamu} untuk tetap memusatkan perhatian pada pelajaran dan mengesampingkan gangguan.",
        "Melatih keterampilan mendengarkan secara aktif, seperti memperhatikan pembicara, akan membantu {○○|kamu} menangkap setiap gagasan utama.",
        "Saya mendorong {○○|kamu} untuk hanya mengeluarkan perlengkapan yang diperlukan di atas meja agar lebih mudah berkonsentrasi.",
        "Terus membangun fokus saat bekerja mandiri akan membantu {○○|kamu} menyelesaikan tugas dengan percaya diri."
      ],
      "w_careful": [
        "Meluangkan waktu sejenak untuk memeriksa kembali pekerjaan sebelum dikumpulkan akan membantu {○○|kamu} menghindari kesalahan kecil.",
        "Langkah selanjutnya bagi {○○|kamu} adalah tidak terburu-buru dan memeriksa kembali jawaban.",
        "Membaca setiap pertanyaan dua kali sebelum menjawab akan membantu {○○|kamu} menyadari kesalahan kecil.",
        "Saya mendorong {○○|kamu} untuk menggunakan daftar periksa singkat sebelum mengumpulkan tugas.",
        "Meluangkan waktu untuk meninjau kembali jawaban di akhir setiap tugas akan membuat hasil kerja {N} semakin akurat."
      ],
      "w_homework": [
        "Menetapkan rutinitas pengerjaan PR yang teratur akan membantu {○○|kamu} mengumpulkan tugas tepat waktu.",
        "Saya mendorong {○○|kamu} untuk memeriksa daftar PR setiap hari agar tidak ada yang terlewat.",
        "Menggunakan map khusus PR untuk membawa tugas antara rumah dan sekolah akan membantu menjaga semuanya tetap teratur.",
        "Langkah selanjutnya bagi {○○|kamu} adalah mulai mengerjakan PR pada waktu yang sama setiap hari.",
        "Memasukkan PR yang sudah selesai ke dalam tas pada malam sebelumnya akan membantu agar tugas tiba di sekolah tepat waktu."
      ],
      "w_handwriting": [
        "Menulis dengan tidak terburu-buru akan membantu tulisan tangan {N} menjadi lebih rapi dan mudah dibaca.",
        "Langkah selanjutnya adalah lebih memperhatikan kerapian tulisan tangan dan penyajian tugas.",
        "Berlatih menulis bentuk huruf selama beberapa menit sehari akan membantu tulisan {N} terlihat lebih rapi.",
        "Saya mendorong {○○|kamu} untuk memberi jarak yang jelas antar-kata dan menjaga agar huruf tetap berada di atas garis.",
        "Meluangkan sedikit lebih banyak waktu untuk kerapian penyajian akan membantu ide-ide bagus {N} semakin menonjol."
      ],
      "w_speak": [
        "Saya mendorong {○○|kamu} untuk lebih sering menyampaikan ide di kelas, karena pemikiran {○○|kamu} sangat berharga.",
        "Langkah selanjutnya adalah lebih sering mengangkat tangan dan berpartisipasi dalam diskusi kelas.",
        "Melatih penyampaian ide bersama teman sebangku terlebih dahulu akan membantu {○○|kamu} merasa siap berbicara di depan seluruh kelas.",
        "Saya mendorong {○○|kamu} untuk menetapkan target kecil, yaitu memberikan satu tanggapan dalam setiap diskusi.",
        "Lebih sering menyampaikan pemikiran {○○|kamu} secara lisan akan membantu teman-teman sekelas belajar dari {○○|kamu} juga."
      ],
      "w_emotion": [
        "Langkah selanjutnya bagi {○○|kamu} adalah menarik napas dalam-dalam saat merasa kesal, lalu menggunakan kata-kata untuk menyampaikan perasaan.",
        "Mempraktikkan cara menenangkan diri akan membantu {○○|kamu} mengatasi rasa frustrasi.",
        "Mengungkapkan perasaan yang sedang dialami secara lisan akan membantu {○○|kamu} mendapatkan bantuan yang tepat dengan cepat.",
        "Saya mendorong {○○|kamu} untuk mengambil jeda singkat dan menghitung sampai lima saat menghadapi situasi yang terasa sulit.",
        "Langkah selanjutnya adalah melatih cara-cara yang tenang untuk menghadapi kekecewaan, seperti menarik napas perlahan."
      ],
      "w_friends": [
        "Saya mendorong {○○|kamu} untuk mendengarkan pendapat orang lain dan menggunakan kata-kata yang baik saat terjadi perbedaan pendapat.",
        "Terus melatih kesabaran terhadap teman sekelas akan membantu pertemanan berkembang lebih baik.",
        "Saya mendorong {○○|kamu} untuk mengajak teman-teman sekelas yang beragam agar ikut bergabung saat kerja kelompok maupun bermain.",
        "Berlatih menunggu giliran dan berbagi akan membantu pertemanan {N} tumbuh semakin erat.",
        "Langkah selanjutnya bagi {○○|kamu} adalah membicarakan perbedaan pendapat dengan tenang dan mencari solusi yang adil."
      ],
      "w_tidy": [
        "Meluangkan waktu satu menit setiap hari untuk merapikan meja dan tas {N} akan membuat kegiatan belajar berjalan lebih lancar.",
        "Langkah selanjutnya adalah menjaga perlengkapan belajar tetap rapi dan siap digunakan di kelas.",
        "Menggunakan daftar periksa sederhana di akhir jam sekolah akan membantu {○○|kamu} menjaga perlengkapan tetap teratur.",
        "Saya mendorong {○○|kamu} untuk mengembalikan setiap barang ke tempatnya segera setelah selesai digunakan.",
        "Langkah selanjutnya adalah menjaga map tetap tertata rapi sehingga lembar kerja mudah ditemukan."
      ],
      "w_reading": [
        "Membaca selama sepuluh menit setiap hari akan membantu {○○|kamu} memperkaya kosakata dan pemahaman bacaan.",
        "Saya mendorong {○○|kamu} untuk mengeksplorasi lebih banyak buku di rumah.",
        "Membaca dengan suara lantang selama beberapa menit hampir setiap hari akan membantu membangun kelancaran dan kepercayaan diri.",
        "Saya mendorong {○○|kamu} untuk mencoba membaca buku dari genre baru, seperti nonfiksi atau puisi.",
        "Berdiskusi tentang setiap buku setelah selesai membacanya akan membantu {○○|kamu} memperdalam pemahaman."
      ],
      "w_initiative": [
        "Langkah selanjutnya bagi {○○|kamu} adalah segera meminta bantuan saat ada hal yang belum jelas.",
        "Mengambil lebih banyak inisiatif dalam belajar akan membantu {○○|kamu} berkembang ke tahap berikutnya.",
        "Saya mendorong {○○|kamu} untuk mengajukan pertanyaan kapan pun rasa ingin tahu muncul.",
        "Mengambil langkah pertama untuk memulai tugas secara mandiri akan membantu {○○|kamu} berkembang sebagai pembelajar.",
        "Langkah selanjutnya adalah mencari tantangan tambahan setelah menyelesaikan tugas kelas."
      ],
      "w_rules": [
        "Saya mendorong {○○|kamu} untuk terus mengikuti rutinitas kelas, seperti bergiliran dan menunggu dengan sabar.",
        "Langkah selanjutnya adalah selalu mengingat kesepakatan kelas sepanjang hari.",
        "Terus mengikuti kesepakatan kelas saat pergantian kegiatan akan membantu hari berjalan dengan lancar.",
        "Saya mendorong {○○|kamu} untuk berhenti sejenak dan memikirkan bagaimana pilihan tindakan berdampak pada orang lain.",
        "Berlatih menunggu giliran berbicara akan membantu {○○|kamu} menunjukkan rasa hormat kepada teman sekelas."
      ],
      "w_confidence": [
        "Saya mendorong {○○|kamu} untuk berani mencoba tantangan baru, karena kesalahan adalah bagian dari proses belajar.",
        "Langkah selanjutnya adalah sedikit lebih percaya pada {kemampuan ○○ sendiri|dirimu sendiri}.",
        "Mengambil satu tantangan baru setiap minggu akan membantu {○○|kamu} membangun kepercayaan diri.",
        "Saya mendorong {○○|kamu} untuk merayakan keberhasilan kecil dan mengingat bahwa usaha adalah hal yang terpenting.",
        "Langkah selanjutnya adalah sesekali mencoba pilihan yang lebih menantang, dengan menyadari bahwa bantuan selalu tersedia."
      ],
      "w_time": [
        "Menggunakan jadwal sederhana untuk mengatur PR dan mengulang pelajaran akan membantu {○○|kamu} merasa tidak terburu-buru.",
        "Langkah selanjutnya adalah berlatih mengatur waktu dan memprioritaskan tugas.",
        "Membagi tugas besar menjadi langkah-langkah yang lebih kecil akan membantu {○○|kamu} menyelesaikan pekerjaan tepat waktu.",
        "Saya mendorong {○○|kamu} untuk memulai tugas panjang lebih awal daripada menundanya hingga saat-saat terakhir.",
        "Menggunakan pengatur waktu saat mengerjakan tugas akan membantu {○○|kamu} tetap fokus."
      ]
    },
    "areas": {
      "chinese": {
        "subj": "Bahasa",
        "c": "membaca dan kosakata",
        "k": "membaca dan menulis",
        "w": "tugas tertulis"
      },
      "math": {
        "subj": "Matematika",
        "c": "konsep bilangan dan geometri",
        "k": "berhitung dan pemecahan masalah",
        "w": "tugas latihan"
      },
      "english": {
        "subj": "Bahasa Inggris",
        "c": "kosakata dan pola kalimat",
        "k": "menyimak dan berbicara",
        "w": "PR Bahasa Inggris"
      },
      "social": {
        "subj": "Ilmu Pengetahuan Sosial (IPS)",
        "c": "topik masyarakat dan sejarah",
        "k": "riset dan presentasi",
        "w": "tugas proyek"
      },
      "science": {
        "subj": "IPA",
        "c": "konsep dasar sains",
        "k": "pengamatan dan percobaan",
        "w": "kegiatan praktikum"
      },
      "arts": {
        "subj": "Seni",
        "c": "ide dasar seni rupa dan musik",
        "k": "berkarya dan tampil",
        "w": "karya seni"
      },
      "pe": {
        "subj": "PJOK",
        "c": "hidup sehat",
        "k": "keterampilan gerak",
        "w": "tugas PJOK"
      },
      "integrative": {
        "subj": "Kecakapan Hidup",
        "c": "kesadaran diri dan kecakapan hidup",
        "k": "kegiatan kelompok",
        "w": "tugas kegiatan"
      },
      "life": {
        "subj": "Studi Lingkungan",
        "c": "dunia di sekitar kita",
        "k": "mengamati dan membuat karya",
        "w": "tugas proyek"
      }
    },
    "frames": {
      "openings": [
        {
          "t": "Senang sekali memiliki ○○ di kelas pada semester ini.",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "○○ telah menjalani semester yang luar biasa.",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "Sungguh semester yang hebat bagi ○○!",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "Senang sekali memiliki kamu di kelas kita pada semester ini.",
          "u": [
            "term"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "○○, kamu telah menjalani semester yang luar biasa!",
          "u": [
            "term"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "○○ telah menjalani semester yang sukses.",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "formal"
        },
        {
          "t": "{○○|Kamu} telah menunjukkan perkembangan yang stabil semester ini.",
          "u": [
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "{○○|Kamu} telah menunjukkan kedewasaan yang makin berkembang semester ini.",
          "u": [
            "term"
          ],
          "g": [
            "high"
          ]
        },
        {
          "t": "{○○|Kamu} belajar dengan baik di kelas akhir-akhir ini.",
          "u": [
            "brief"
          ]
        },
        {
          "t": "Saya ingin membagikan kabar baik tentang ○○.",
          "u": [
            "brief",
            "cheer"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "○○, kerja bagus hari ini!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "○○, saya melihat sesuatu yang luar biasa hari ini!",
          "u": [
            "cheer"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "{○○|Kamu} telah membuat kemajuan yang sangat pesat semester ini.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "Semester ini membawa perkembangan yang begitu besar bagi {○○|kamu}!",
          "u": [
            "special"
          ],
          "f": "progress",
          "tone": "warm"
        },
        {
          "t": "Setiap anak belajar dengan ritme yang berbeda, dan ○○ berkembang dengan stabil.",
          "u": [
            "special"
          ],
          "f": "support",
          "p": "parent"
        },
        {
          "t": "Setiap orang belajar dengan ritme yang berbeda, dan kamu berkembang dengan stabil.",
          "u": [
            "special"
          ],
          "f": "support",
          "p": "child"
        },
        {
          "t": "{○○|Kamu} telah menjalani semester yang aktif dan produktif.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Semester ini menjadi masa perkembangan yang nyata bagi {○○|kamu}.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Sungguh menyenangkan mengajar {○○|kamu} pada semester ini.",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "Saya senang dapat mengenal {○○|kamu} lebih dekat pada semester ini.",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "{○○|Kamu} telah mengerjakan tugas-tugas semester ini dengan kemandirian yang terus meningkat.",
          "u": [
            "term"
          ],
          "g": [
            "high"
          ]
        },
        {
          "t": "Laporan ini merangkum kemajuan dan kelebihan {N} pada semester ini.",
          "u": [
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "Berikut kabar singkat mengenai perkembangan {○○|kamu}.",
          "u": [
            "brief"
          ]
        },
        {
          "t": "{○○|Kamu} telah melewati beberapa minggu yang baik di kelas.",
          "u": [
            "brief"
          ]
        },
        {
          "t": "Semuanya berjalan dengan baik bagi {○○|kamu} di kelas.",
          "u": [
            "brief"
          ],
          "tone": "warm"
        },
        {
          "t": "Saya ingin menyampaikan beberapa hal positif tentang ○○.",
          "u": [
            "cheer"
          ],
          "p": "parent"
        },
        {
          "t": "Berikut catatan kecil untuk mengapresiasi ○○.",
          "u": [
            "cheer"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "○○ patut mendapatkan pujian.",
          "u": [
            "cheer"
          ],
          "p": "parent"
        },
        {
          "t": "○○, ini catatan khusus untukmu.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "○○, kamu patut bangga pada dirimu sendiri.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Kerja bagus, ○○!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Perkembangan {N} pada semester ini terlihat dengan jelas.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "Semester ini merupakan masa kemajuan yang nyata bagi {○○|kamu}.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "{○○|Kamu} telah mengambil langkah maju yang penting pada semester ini.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "{○○|Kamu} membuat kemajuan dengan ritme yang nyaman, selangkah demi selangkah.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Belajar membutuhkan waktu, dan {○○|kamu} sedang membangun keterampilan dengan stabil.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Saya senang membagikan hal-hal baik yang telah {○○|kamu} lakukan pada semester ini.",
          "u": [
            "special"
          ],
          "f": "support",
          "tone": "warm"
        }
      ],
      "fillers": [
        {
          "t": "Sungguh membanggakan melihat {○○|kamu} berkembang selama beberapa bulan ini.",
          "u": [
            "term",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "Kualitas-kualitas ini menjadikan {○○|kamu} anggota kelas yang berharga.",
          "u": [
            "term",
            "brief"
          ]
        },
        {
          "t": "Terima kasih atas dukungan Bapak/Ibu di rumah.",
          "u": [
            "term",
            "brief",
            "special"
          ],
          "p": "parent"
        },
        {
          "t": "Secara keseluruhan, performa {○○|kamu} pada semester ini sangat konsisten.",
          "u": [
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "Kemajuan ini adalah hasil dari usaha harian yang konsisten.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "Dengan latihan yang berkelanjutan, saya yakin {○○|kamu} akan melihat hasilnya.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Saya akan terus mendukung {○○|kamu} di sekolah.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "{○○|Kamu} telah berusaha dengan konsisten pada semester ini.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Kemajuan secara keseluruhan di bidang ini sudah baik.",
          "u": [
            "subject"
          ],
          "tone": "formal"
        },
        {
          "t": "{N} berpartisipasi dengan baik dalam pelajaran {subj} dan menyelesaikan tugas-tugas kelas.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "{N} sedang membangun keterampilan yang stabil dalam {subj}.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Usahamu selalu terlihat dan dihargai.",
          "u": [
            "cheer",
            "brief"
          ],
          "p": "child"
        },
        {
          "t": "{○○|Kamu} telah beradaptasi dengan baik dalam rutinitas kelas kita dan menjalani setiap hari dengan sikap yang baik.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "{○○|Kamu} telah memberikan banyak kontribusi positif bagi komunitas kelas kita pada semester ini.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Senang sekali melihat kelebihan {N} berkembang sepanjang semester ini.",
          "u": [
            "term",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "Sepanjang semester ini, {○○|kamu} telah memenuhi harapan dengan usaha yang konsisten dan positif.",
          "u": [
            "term",
            "special"
          ],
          "tone": "formal"
        },
        {
          "t": "{○○|Kamu} terus berkembang sebagai pembelajar maupun sebagai anggota kelas.",
          "u": [
            "term",
            "special",
            "brief"
          ]
        },
        {
          "t": "{○○|Kamu} menyambut setiap hari di sekolah dengan sikap yang antusias.",
          "u": [
            "term",
            "special",
            "brief"
          ]
        },
        {
          "t": "{○○|Kamu} telah menjadi pribadi yang konsisten dan dapat diandalkan di kelas kita.",
          "u": [
            "term",
            "brief"
          ]
        },
        {
          "t": "Usaha yang {○○|kamu} tunjukkan setiap hari terlihat dengan jelas.",
          "u": [
            "term",
            "special",
            "brief"
          ]
        },
        {
          "t": "{○○|Kamu} telah membangun hubungan yang baik dengan teman sekelas maupun guru.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "Terlihat jelas bahwa {○○|kamu} peduli untuk melakukan yang terbaik di sekolah.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "{○○|Kamu} makin mandiri seiring berjalannya semester ini.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "Sikap positif {N} membantu seluruh kelas belajar dengan baik.",
          "u": [
            "term",
            "brief"
          ]
        },
        {
          "t": "Saya senang melihat kepercayaan diri {N} tumbuh dari minggu ke minggu.",
          "u": [
            "term",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "Sikap {N} terhadap pembelajaran selalu konsisten dan positif.",
          "u": [
            "term",
            "special"
          ],
          "tone": "formal"
        },
        {
          "t": "Langkah-langkah kecil yang konsisten membuahkan kemajuan nyata bagi {○○|kamu}.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Setiap minggu membawa kesempatan baru untuk berlatih, dan {○○|kamu} memanfaatkannya dengan baik.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Peningkatan pada semester ini menunjukkan hasil dari usaha yang konsisten.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "{N} mengikuti instruksi dengan baik dalam pelajaran {subj} dan bekerja dengan teliti.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "{N} sedang mengembangkan kebiasaan belajar yang baik dalam {subj}.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Hasil kerja {N} dalam {subj} pada semester ini mencerminkan usaha yang konsisten.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Secara keseluruhan, usaha yang ditunjukkan dalam {subj} telah konsisten.",
          "u": [
            "subject"
          ],
          "tone": "formal"
        },
        {
          "t": "Setiap langkah kecil yang kamu ambil sangat berarti.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Kerja kerasmu membawa perubahan yang nyata.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Usaha ○○ selalu terlihat dan dihargai.",
          "u": [
            "cheer",
            "brief"
          ],
          "p": "parent"
        }
      ],
      "closings": [
        {
          "t": "{Semoga ○○ dapat terus mempertahankan kerja hebat ini!|Pertahankan kerja hebat ini!}",
          "u": [
            "term",
            "brief",
            "cheer",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "{Semoga ○○ dapat terus mempertahankan kerja bagus ini.|Pertahankan kerja bagus ini.}",
          "u": [
            "term",
            "brief",
            "subject",
            "special"
          ],
          "tone": "formal"
        },
        {
          "t": "Saya menantikan {○○|kamu} terus bersinar di semester berikutnya.",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "Saya yakin {○○|kamu} akan menjalani semester depan dengan lebih baik lagi.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "Saya mendoakan kesuksesan bagi {○○|kamu} di tahap selanjutnya.",
          "u": [
            "term"
          ],
          "g": [
            "high"
          ]
        },
        {
          "t": "{Semoga prestasi baik ini terus berlanjut!|Pertahankan!}",
          "u": [
            "brief",
            "cheer",
            "subject"
          ]
        },
        {
          "t": "Saya bangga padamu!",
          "u": [
            "cheer",
            "special"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "Teruslah bersinar!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Bersama-sama, kita akan terus berusaha mencapai tujuan ini.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "{○○ telah menunjukkan kinerja yang sangat baik pada semester ini.|Kerja bagus pada semester ini.}",
          "u": [
            "subject",
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "Saya menantikan semua hal yang akan {○○|kamu} capai di semester berikutnya.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Semoga semester depan kembali berjalan dengan luar biasa!",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "Semoga {○○|kamu} dapat menikmati liburan yang menenangkan dan memulai semester depan dengan semangat baru.",
          "u": [
            "term"
          ]
        },
        {
          "t": "{○○|Kamu} patut bangga atas pencapaian pada semester ini.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Merupakan suatu kehormatan dapat mengajar ○○ pada semester ini.",
          "u": [
            "term"
          ],
          "p": "parent"
        },
        {
          "t": "Terima kasih atas semua kerja kerasmu pada semester ini.",
          "u": [
            "term"
          ],
          "p": "child"
        },
        {
          "t": "Saya akan terus mengabari Bapak/Ibu mengenai perkembangan ○○.",
          "u": [
            "brief"
          ],
          "p": "parent"
        },
        {
          "t": "Banyak perkembangan baik yang sedang terjadi, {dan saya yakin ○○ akan terus bersemangat!|jadi teruslah semangat!}",
          "u": [
            "brief",
            "cheer"
          ],
          "tone": "warm"
        },
        {
          "t": "Usaha yang konsisten seperti ini akan membawa {○○|kamu} melangkah jauh.",
          "u": [
            "brief",
            "cheer",
            "special"
          ]
        },
        {
          "t": "{○○|Kamu} sudah berada di jalur yang tepat.",
          "u": [
            "brief",
            "subject",
            "special"
          ]
        },
        {
          "t": "Saya menantikan kemajuan lebih lanjut dalam {subj}.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Latihan yang berkelanjutan akan makin memperkuat kelebihan ini.",
          "u": [
            "subject",
            "special"
          ]
        },
        {
          "t": "{○○ telah bekerja dengan baik dan terus melangkah maju.|Kerja bagus, dan teruslah melangkah maju.}",
          "u": [
            "cheer",
            "brief"
          ]
        },
        {
          "t": "Kamu pasti bisa!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Setiap langkah maju sangat berarti, dan masih banyak lagi pencapaian yang menanti di depan.",
          "u": [
            "special"
          ],
          "f": "support"
        }
      ]
    },
    "elaborations": {
      "area": [
        "Hal ini mencerminkan dasar yang kuat dalam {subj}.",
        "Kemajuan {N} dalam {subj} sangat menggembirakan.",
        "Secara keseluruhan, hasil kerja dalam {subj} sudah mantap.",
        "Kualitas hasil kerja {N} dalam {subj} mencerminkan ketelitian yang nyata.",
        "Ini adalah bekal yang kuat untuk tahap pembelajaran selanjutnya dalam {subj}.",
        "{○○|Kamu} sudah sangat siap untuk langkah selanjutnya dalam {subj}.",
        "Sangat menggembirakan melihat perkembangan ini dalam {subj}."
      ],
      "learning": [
        "Pendekatan belajar ini telah memberi {○○|kamu} dasar yang kuat di berbagai mata pelajaran.",
        "Kebiasaan-kebiasaan ini akan sangat bermanfaat bagi {○○|kamu} di tahun-tahun mendatang.",
        "Hasilnya, hasil kerja {N} konsisten sangat baik.",
        "{○○|Kamu} sedang membangun kebiasaan yang membawa pada keberhasilan jangka panjang.",
        "Pendekatan yang konsisten ini tercermin dalam kualitas tugas harian {N}.",
        "Sikap positif seperti ini membuat mengajar {○○|kamu} menjadi menyenangkan.",
        "Kelebihan-kelebihan ini membantu {○○|kamu} memaksimalkan setiap pelajaran."
      ],
      "character": [
        "Sifat-sifat baik ini bahkan lebih penting daripada nilai.",
        "{○○|Kamu} telah mendapatkan respek dari teman sekelas maupun guru.",
        "Sangat menyenangkan melihat karakter sebaik ini setiap hari.",
        "Teman-teman sekelas tahu bahwa mereka bisa mengandalkan {○○|kamu}.",
        "{○○|Kamu} memberi teladan dengan cara yang tenang namun bermakna.",
        "Karakter seperti ini membantu membangun suasana kelas yang penuh kepedulian.",
        "Kualitas diri seperti ini akan sangat berguna bagi {○○|kamu} jauh di luar bangku sekolah."
      ],
      "social": [
        "Teman-teman sekelas senang belajar dan bermain bersama {○○|kamu}.",
        "{○○|Kamu} ikut membuat kelas kita menjadi tempat yang hangat dan ramah.",
        "Keterampilan sosial ini adalah anugerah yang berharga.",
        "Kegiatan kelompok berjalan lebih lancar saat {○○|kamu} ada di dalam tim.",
        "Kemampuan ini membantu semua teman di kelas merasa dirangkul.",
        "Bekerja sama dengan baik bersama orang lain adalah salah satu keterampilan paling berharga.",
        "{○○|Kamu} mendorong hal terbaik dari orang-orang di {sekitarnya|sekitarmu}."
      ],
      "routine": [
        "Kebiasaan baik ini membuat proses belajar menjadi lebih efisien.",
        "{○○|Kamu} memberikan contoh positif bagi teman-teman yang lain.",
        "Mengelola tugas sehari-hari dengan baik adalah langkah penting dalam bertumbuh dewasa.",
        "Sikap siap dan teratur memberikan lebih banyak waktu untuk belajar.",
        "Rutinitas ini memberi {○○|kamu} awal hari yang tenang dan mantap.",
        "Kebiasaan baik seperti ini membangun kemandirian yang sesungguhnya.",
        "{○○|Kamu} menunjukkan bahwa kebiasaan kecil sehari-hari membawa perubahan besar."
      ],
      "service": [
        "Kemauan untuk membantu ini membuat kelas kita menjadi tempat yang lebih baik.",
        "Berkat bantuan {N}, rutinitas kelas berjalan lebih lancar.",
        "Meluangkan waktu untuk membantu orang lain adalah hal yang patut dibanggakan.",
        "Membantu dengan cara seperti ini menunjukkan kedewasaan yang nyata.",
        "{○○|Kamu} menjalankan tugas-tugas ini dengan ceria, dan hal itu sangat dihargai.",
        "Komunitas kelas kita menjadi lebih kuat karena bantuan seperti ini.",
        "Semangat melayani ini adalah kualitas diri yang patut dijaga."
      ],
      "talent": [
        "Saya berharap {○○|kamu} terus mengembangkan bakat ini.",
        "Bakat ini memberi banyak warna pada kegiatan kelas kita.",
        "Sangat menyenangkan melihat bakat ini terus berkembang.",
        "Sungguh indah melihat {○○|kamu} membagikan bakat ini bersama teman sekelas.",
        "{○○|Kamu} sangat pantas merasa bangga atas bakat ini.",
        "Dengan latihan yang terus-menerus, bakat ini akan makin berkembang.",
        "Kelebihan ini memberi {○○|kamu} kesempatan untuk bersinar dengan cara yang istimewa."
      ],
      "progress": [
        "Kemajuan ini tidak diraih dengan mudah dan sangat layak diapresiasi.",
        "Terlihat jelas bahwa {○○|kamu} telah berusaha sangat keras.",
        "Saya sungguh senang melihat perubahan ini.",
        "Perkembangan ini menunjukkan apa yang bisa dicapai melalui usaha yang tekun.",
        "{○○|Kamu} telah berkembang sangat jauh, dan hal itu patut dirayakan.",
        "Setiap langkah kecil telah terkumpul menjadi perubahan yang nyata.",
        "Kemajuan ini menjadi bekal yang sangat baik untuk bulan-bulan ke depan."
      ]
    },
    "compact": [
      {
        "t": "{○○|Kamu} telah menunjukkan banyak kelebihan, termasuk {L}."
      },
      {
        "t": "Hal yang menonjol antara lain {L}."
      },
      {
        "t": "Kelebihan {○○|kamu} meliputi {L}."
      },
      {
        "t": "{○○|Kamu} menonjol dalam hal {L}."
      },
      {
        "t": "Beberapa kelebihan {○○|kamu} adalah {L}."
      },
      {
        "t": "Kelebihan utama semester ini adalah {L}.",
        "tone": "formal"
      },
      {
        "t": "Sangat menyenangkan melihat {L} sepanjang semester ini.",
        "tone": "warm",
        "u": [
          "term",
          "brief",
          "special"
        ]
      },
      {
        "t": "Saya senang dapat menyoroti {L}.",
        "tone": "formal"
      }
    ],
    "connectors": [
      "Selain itu, ",
      "Di samping itu, ",
      "Lebih dari itu, "
    ],
    "wishLeads": [
      "",
      "",
      "Ke depannya, "
    ],
    "you": "kamu",
    "possessive": "kamu",
    "blankName": "[Nama]",
    "and": "dan",
    "unit": "kata"
  },
  "roster": {
    "sheet": "Daftar siswa",
    "guideSheet": "Petunjuk",
    "seat": "Nomor absen",
    "name": "Nama siswa",
    "group": "Grup",
    "gender": "Jenis kelamin",
    "avatar": "Jenis avatar",
    "instructions": [
      "Isi lembar Daftar siswa saja, satu siswa per baris.",
      "Pertahankan judul pada baris pertama. Hanya Nama siswa yang wajib diisi.",
      "Nomor absen bersifat opsional. Format nilai seperti 01 dan 02 sebagai teks agar angka nol di depan tidak hilang.",
      "Nama maksimal 30 karakter dan harus unik di dalam kelas. Impor maksimal 100 siswa sekaligus.",
      "Mengimpor siswa saat pengaturan awal bersifat opsional. Anda dapat menambahkannya nanti di halaman Siswa.",
      "Gunakan .xlsx, .xls, .ods, atau CSV UTF-8. CSV hanya menyimpan satu lembar dan teks biasa.",
      "Jangan sertakan rumus, makro, nomor telepon, alamat email, atau data pribadi siswa lainnya yang tidak diperlukan.",
      "Lembar daftar siswa masih kosong. Panduan ini tidak ikut diimpor."
    ],
    "male": "laki-laki",
    "female": "perempuan"
  },
  "demo": {
    "teacher": "Ibu Kartika",
    "workspace": "Ruang Kelas Contoh ClassMori",
    "className": "Kelas 3A Nusantara",
    "individualClassName": "Kelas 3B Sahabat",
    "cycle": "Siklus Tumbuh 1",
    "pet": "Mori si Kancil",
    "individualPet": "Sahabat Belajar",
    "groups": [
      "Garuda",
      "Cendrawasih",
      "Jalak Bali",
      "Merak"
    ],
    "names": [
      "Adit",
      "Ayu",
      "Bagas",
      "Citra",
      "Dimas",
      "Eka",
      "Fajar",
      "Gita",
      "Hana",
      "Indra",
      "Joko",
      "Kirana",
      "Laras",
      "Miko",
      "Nadia",
      "Putra",
      "Putri",
      "Rafi",
      "Rani",
      "Rizky",
      "Salsa",
      "Sinta",
      "Tegar",
      "Wulan"
    ],
    "surpriseItems": [
      [
        "Kapsul hutan",
        "🎁",
        6,
        "capsule",
        [
          [
            "Pilih satu stiker",
            "🌈",
            "common"
          ],
          [
            "Asisten guru",
            "🤝",
            "common"
          ],
          [
            "Pilih tempat duduk sehari",
            "🪑",
            "uncommon"
          ],
          [
            "Kupon bebas PR",
            "📝",
            "rare"
          ]
        ]
      ],
      [
        "Kartu gosok berhadiah",
        "🍀",
        6,
        "scratch",
        [
          [
            "Pilih musik istirahat",
            "🎵",
            "common"
          ],
          [
            "Duduk dengan teman sehari",
            "👫",
            "uncommon"
          ],
          [
            "Ketua kelas sehari",
            "👑",
            "rare"
          ]
        ]
      ]
    ],
    "routines": [
      "Membaca",
      "Diskusi",
      "Beres-beres"
    ]
  },
  "schema": {
    "home": "Beranda",
    "freeTool": "alat gratis",
    "product": {
      "description": "Poin kelas dan hewan peliharaan kelas untuk guru: pilih siswa, ketuk alasan, dan hewan peliharaan mereka tumbuh seiring bertambahnya poin. Tanpa akun siswa; gratis selamanya untuk 1 kelas.",
      "free": "Paket Gratis",
      "yearly": "Paket Plus, tahunan",
      "monthly": "Paket Plus, bulanan",
      "plus": "Paket Pro, tahunan",
      "plusMonthly": "Paket Pro, bulanan"
    },
    "socialAlt": "ClassMori: guru dan siswa di kelas bertema hutan bersama hewan peliharaan kelas mereka"
  },
  "corePages": {
    "/": {
      "title": "ClassMori | Poin kelas yang menumbuhkan hewan peliharaan untuk setiap siswa",
      "description": "Aplikasi poin kelas dan hewan peliharaan kelas untuk guru: pilih siswa, ketuk alasan, dan lihat hewan peliharaan mereka tumbuh di setiap poin. Satu hewan peliharaan per siswa atau satu untuk seluruh kelas. Bisa di proyektor atau ponsel, tanpa akun siswa. Gratis untuk 1 kelas hingga 40 siswa."
    },
    "/about": {
      "title": "Tentang kami | ClassMori",
      "description": "Kenali ClassMori: umpan balik positif yang spesifik dan sahabat hutan yang membantu guru melihat perkembangan setiap anak."
    },
    "/pricing": {
      "title": "Harga | ClassMori",
      "description": "ClassMori gratis selamanya untuk 1 kelas hingga 40 siswa. Paket Plus seharga US$3 per bulan atau US$19 per tahun (US$9,90 di tahun pertama Anda) untuk 5 kelas berisi 100 siswa. Paket Pro dan penawaran harga untuk sekolah juga tersedia."
    },
    "/tour": {
      "title": "Coba dasbor guru | ClassMori",
      "description": "Tidak perlu mendaftar: coba mode hewan peliharaan kelas dan hewan peliharaan untuk setiap siswa. Pilih siswa, beri poin, dan lihat perubahan hewan peliharaannya. Perubahan hanya tersimpan di halaman ini dan diatur ulang saat dimuat ulang; semua siswa bersifat fiktif."
    },
    "/privacy": {
      "title": "Kebijakan privasi | ClassMori",
      "description": "Cara ClassMori menangani akun guru dan data kelas, serta cara mengajukan permintaan data Anda."
    },
    "/terms": {
      "title": "Ketentuan layanan | ClassMori",
      "description": "Ketentuan layanan, cakupan layanan, dan aturan akun ClassMori."
    },
    "/contact": {
      "title": "Hubungi kami | ClassMori",
      "description": "Ada pertanyaan, saran, atau pembelian untuk sekolah? Hubungi tim ClassMori."
    }
  },
  "scene": {
    "pets": {
      "otter": {
        "name": "Mori",
        "species": "berang-berang",
        "foodName": "udang"
      },
      "rabbit": {
        "name": "Gembul",
        "species": "kelinci",
        "foodName": "wortel"
      },
      "penguin": {
        "name": "Mochi",
        "species": "penguin",
        "foodName": "ikan"
      }
    },
    "lines": {
      "calm": [
        "Aku di sini menemanimu. Pelan-pelan saja, ya.",
        "Langkah kecil juga patut dirayakan!",
        "Siap? Yuk, kita mulai bersama!",
        "Selangkah demi selangkah, kita makin maju.",
        "Tarik napas dalam-dalam. Tugas kecil yang baru sudah menanti.",
        "Ada banyak sekali hal baru untuk dijelajahi hari ini!",
        "Ini sedikit semangat dan keberanian untukmu.",
        "Idemu sangat berharga untuk dibagikan!",
        "Yuk, kita buat hari ini terasa hangat bersama-sama.",
        "Aku senang sekali belajar bersamamu!"
      ],
      "react": [
        "Wah, terima kasih sudah begitu baik!",
        "Terima kasih, rasanya hangat sekali.",
        "Hehe, senang sekali kita bisa berteman!",
        "Satu sentuhan kecil yang penuh kehangatan.",
        "Ini hati yang besar untukmu!",
        "Hari ini jadi makin seru karena ada kamu.",
        "Yuk, bagikan suasana hati yang ceria ke semua orang!",
        "Kamu sehangat sinar matahari pagi.",
        "Kebaikan kecil membuat semua orang bahagia!",
        "Hatiku melambai gembira padamu!"
      ],
      "wave": [
        "Hai! Yuk, lakukan yang terbaik hari ini!",
        "Melihatmu membuatku senang sekali!",
        "Dadah, dadah! Suasana hati yang ceria datang!",
        "Halo! Siap belajar bersama?",
        "Berikan senyuman kepada teman di sebelahmu!",
        "Sapaanmu baru saja mencerahkan hutan kecil ini.",
        "Sapalah teman di dekatmu!",
        "Sikap sopan membuat hati terasa hangat.",
        "Satu lambaian kecil, tambah lagi keberanianmu!",
        "Semua teman sudah berkumpul. Ayo kita mulai!"
      ],
      "eat": [
        "Terima kasih atas {food} ini! Aku makan pelan-pelan, ya.",
        "Kamu perhatian sekali pada teman-temanmu.",
        "Ngemil sebentar, lalu kita lanjut lagi!",
        "Nyam! Suasana hati yang ceria langsung masuk ke perutku!",
        "Kamu merawatku dengan sangat baik.",
        "Berbagi membuat kebahagiaan makin bertambah!",
        "{food} ini penuh dengan kebaikan hati.",
        "Perutku sudah kenyang dan siap menghadapi tantangan baru!",
        "Terima kasih sudah ingat untuk merawatku.",
        "Sudah kenyang! Ini senyuman manis untukmu!"
      ],
      "drink": [
        "Glek, glek, terima kasih sudah memperhatikanku!",
        "Seteguk air membuat kita kembali berenergi!",
        "Jangan lupa minum air juga, ya!",
        "Tetesan air yang segar membawa suasana hati yang ceria.",
        "Merawat diri sendiri itu hal yang hebat!",
        "Istirahat sebentar, lalu lanjut lagi.",
        "Terima kasih, seteguk air tadi menghangatkan hatiku!",
        "Waktunya minum air bersama selesai!",
        "Saat tubuh terasa segar, belajar jadi lebih nyaman.",
        "Segar kembali dan siap menemukan hal-hal baru!"
      ],
      "stretch": [
        "Rentangkan tubuhmu, energi pun kembali!",
        "Angkat tangan tinggi-tinggi, sambut suasana hati yang ceria!",
        "Putar bahumu dan beri semangat untuk dirimu sendiri.",
        "Istirahat sejenak membantu kita melangkah lebih jauh.",
        "Tarik napas dalam-dalam. Yuk, rileks bersama.",
        "Dari kepala sampai ujung kaki, semuanya siap!",
        "Kamu sudah berusaha keras. Jaga dirimu juga, ya.",
        "Rentangkan badan, tebarkan senyuman!",
        "Istirahat sejenak membantu kita mengambil langkah berikutnya.",
        "Jauh lebih segar! Yuk, kita coba lagi bersama!"
      ],
      "celebrate": [
        "Kerja bagus! Ini bintang usaha untukmu!",
        "Aku melihat betapa sungguh-sungguhnya usahamu!",
        "Tugas yang diselesaikan dengan baik patut diberi tepuk tangan!",
        "Kamu sudah berani mencoba. Hebat sekali!",
        "Ada kemajuan lagi hari ini. Hore!",
        "Kamu mengerjakannya dengan sangat teliti. Keren!",
        "Ini semangat untukmu. Teruslah bersinar!",
        "Setiap usaha sekecil apa pun layak dihargai!",
        "Kamu melakukannya dengan sangat baik, aku sampai melompat kegirangan!",
        "Yey! Mari kita semua bertepuk tangan untuk kemajuanmu!"
      ],
      "sleep": [
        "Istirahat sebentar untuk memulihkan energiku.",
        "Ahh… Aku di sini bersamamu di hutan kecil.",
        "Suasana tenang membuat hatiku terasa damai.",
        "Menyimpan kemajuan hari ini ke dalam mimpi indah.",
        "Setelah berusaha keras, istirahatlah dengan nyenyak juga!",
        "Bulan kecil datang membawa mimpi yang nyaman.",
        "Pejamkan matamu dan simpan senyuman untuk dirimu sendiri.",
        "Sudah cukup istirahat. Yuk, kita berpetualang lagi.",
        "Terima kasih sudah berusaha keras hari ini!",
        "Senyummu juga hadir di dalam mimpi indahku."
      ],
      "jump": [
        "Satu, dua, tiga, melompat kegirangan!",
        "Lompatan kecil untuk mengirimkan kebahagiaan padamu!",
        "Kaki kecilku melangkah penuh sukacita.",
        "Melompat tinggi, keberanian pun ikut bertambah!",
        "Yuk, lambaikan tangan menyapa kebahagiaan!",
        "Mendarat dengan mantap, senyum pun mengembang!",
        "Lompatan kecil yang ceria. Ayo kita mulai!",
        "Tambah lagi tawa ceria di hutan ini!",
        "Bagikan suasana hati yang ceria hari ini!",
        "Bermain bersamamu seru sekali!"
      ],
      "wake": [
        "Aku sudah bangun! Terima kasih sudah membangunkanku dengan lembut.",
        "Ada tugas kecil yang baru. Yuk, kita kerjakan bersama!",
        "Mata berbinar, suasana hati pun cerah!",
        "Sudah cukup istirahat. Aku penuh energi lagi.",
        "Terima kasih sudah menunggu dengan begitu sabar!",
        "Merentangkan badan sebentar dan tersenyum untukmu.",
        "Siap! Yuk, melangkah maju!",
        "Tidur nyenyak, penuh keberanian!",
        "Bangun tidur terasa menyenangkan karena ada kamu di sini.",
        "Hutan kecil sudah bangun. Ayo kita mulai!"
      ],
      "read": [
        "Aku sedang membaca buku kecil yang seru.",
        "Halaman ini bercerita tentang teman-teman di hutan.",
        "Tunggu, aku ingin melihat halaman ini sekali lagi.",
        "Yuk, kita dengarkan cerita ini bersama-sama."
      ],
      "homework": [
        "Aku sedang mengerjakan PR. Hampir selesai!",
        "Menulis pelan-pelan tetap bisa menghasilkan tulisan yang rapi.",
        "Aku pikirkan soal yang ini sebentar lagi, ya.",
        "Selesai! Kita semua makin pintar."
      ],
      "paint": [
        "Aku sedang melukis setangkai bunga kecil.",
        "Kelopak bunganya dulu, baru daunnya.",
        "Apa warna favoritmu?",
        "Sudah selesai! Lukisan ini untukmu."
      ],
      "rope": [
        "Aku sedang lompat tali. Jaga iramanya, ya!",
        "Satu, dua, lompatan yang ringan.",
        "Talinya lewat tepat di bawah kakiku!",
        "Satu lompatan lagi. Seru sekali!"
      ]
    }
  },
  "sceneUi": {
    "ClassMori · Forest pet scene": "ClassMori · Latar Sahabat Hutan",
    "The forest pet's little forest": "Hutan kecil milik sahabat hutan",
    "Forest pet interactive scene": "Latar interaktif sahabat hutan",
    "Your browser needs Canvas support to show the forest pet.": "Browser Anda memerlukan dukungan Canvas untuk menampilkan sahabat hutan.",
    "Hi! Let's do our best today!": "Hai! Yuk, lakukan yang terbaik hari ini!",
    "A gentle pat. Your friend in the egg heard you!": "Elusan yang lembut. Temanmu di dalam telur mendengarmu!",
    "Knock, knock. We're waiting for you out here!": "Tok, tok. Kami menunggumu di luar sini!",
    "Oh? A tiny sound from inside the egg!": "Eh? Ada suara kecil dari dalam telur!",
    "Something is moving in the den. Let's wait quietly.": "Ada yang bergerak di dalam sarang. Yuk, kita tunggu dengan tenang.",
    "Pat the egg": "Elus telur",
    "Knock gently": "Ketuk perlahan",
    "Little wing": "Sayap kecil",
    "Pat to respond": "Elus untuk berinteraksi",
    " · Drag to pick up": " · Seret untuk mengangkat",
    ". Tap to get a reaction; drag to gently pick up.": ". Ketuk untuk melihat reaksi; seret untuk mengangkat dengan lembut."
  },
  "languageSuggestion": {
    "region": "Bahasa",
    "available": "Halaman ini tersedia dalam bahasa Indonesia",
    "view": "Lihat halaman ini dalam bahasa Indonesia",
    "dismiss": "Tutup"
  },
  "heroAlt": "Tampilan proyektor ClassMori dengan siswa fiktif dan peliharaan mereka yang sedang tumbuh.",
  "sceneArrival": {
    "otter": {
      "waiting": "Kresek, kresek… ada sesuatu yang bergerak di dalam lubang pohon.",
      "peek": "{name} mengintip keluar! Siap menyapa semuanya.",
      "hello": "Halo! Terima kasih sudah menunggu dengan sabar."
    },
    "rabbit": {
      "waiting": "Tirai daun bergoyang. {name} sedang beristirahat di dalam.",
      "peek": "Telinga panjang menyembul keluar! {name} ingin menyapa.",
      "hello": "Hai! Ayo semangat belajar dan tumbuh bersama!"
    },
    "penguin": {
      "waiting": "Telurnya sedikit bergoyang. Teman barumu sedang bersiap-siap.",
      "peek": "Cangkangnya terbuka! {name} mengintip dunia luar.",
      "hello": "Cit! Terima kasih sudah menyemangatiku. Aku di sini!"
    }
  },
  "sceneRegions": {
    "ear": "Telinga kanan",
    "earleft": "Telinga kiri",
    "footleft": "Kaki kiri",
    "footright": "Kaki kanan",
    "tail": "Ekor",
    "handleft": "Tangan mungil",
    "wave": "Tangan mungil",
    "wingleft": "Sayap kiri",
    "wingright": "Sayap kanan",
    "tuft": "Jambul kepala",
    "face": "Pipi",
    "body": "Perut",
    "sleep": "Bangunkan perlahan"
  },
  "commentLanguageFaq": {
    "question": "Bisakah saya membuat komentar dalam bahasa lain?",
    "answer": "Ya. Pengaturan baru secara default menggunakan bahasa halaman ini. Gunakan menu Bahasa untuk memilih Bahasa Mandarin, Inggris, Spanyol, Prancis, Portugis Brasil, Turki, Vietnam, atau Indonesia. Komentar menggunakan bank kalimat dalam bahasa yang dipilih; nama akan diisi secara lokal."
  },
  "reasonAliases": {
    "Kumpul PR tepat waktu": "homework",
    "Kerja sama": "teamwork",
    "Fokus di kelas": "focus",
    "Tantangan selesai": "persist",
    "Membantu teman": "helpful",
    "Mengangkat tangan": "speak"
  }
}
